"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: stock/stock.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fstock%2Fstock.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.assetTransferStatusFromJSON = exports.accountClosabilityToJSON = exports.accountClosabilityFromJSON = exports.enrollmentStatusToJSON = exports.enrollmentStatusFromJSON = exports.portfolioRiskLevelToJSON = exports.portfolioRiskLevelFromJSON = exports.stockErrorCodeToJSON = exports.stockErrorCodeFromJSON = exports.ClosedStockAccount = exports.EnrollmentData = exports.InstrumentFundamentals = exports.InstrumentDetails = exports.OrderQuoteFees = exports.OrderQuote = exports.NbboQuoteQuote = exports.NbboQuote = exports.EquityQuote = exports.InstrumentsSearchResult = exports.TradeViolationTransaction = exports.TradeViolation = exports.ExternalAccountData = exports.Restriction = exports.InstrumentCategoryMethodology = exports.InstrumentCategory = exports.Price = exports.AccountPositions = exports.EquityPosition = exports.Enrollment = exports.InvestorProfileData = exports.EmploymentDataPublicCompany = exports.EmploymentDataEmployment = exports.EmploymentData = exports.PersonalData = exports.IdentificationData = exports.EquityQuoteMarketCondition = exports.InvestorProfileDataInvestmentObjective = exports.InvestorProfileDataRiskTolerance = exports.InvestorProfileDataInvestmentExperience = exports.EmploymentDataEmploymentStatus = exports.InstrumentSource = exports.InstrumentRisk = exports.InstrumentStatus = exports.InstrumentType = exports.StockGraduationStatus = exports.AssetTransferStatus = exports.AccountClosability = exports.EnrollmentStatus = exports.PortfolioRiskLevel = exports.StockErrorCode = void 0;
exports.equityQuoteMarketConditionToJSON = exports.equityQuoteMarketConditionFromJSON = exports.investorProfileDataInvestmentObjectiveToJSON = exports.investorProfileDataInvestmentObjectiveFromJSON = exports.investorProfileDataRiskToleranceToJSON = exports.investorProfileDataRiskToleranceFromJSON = exports.investorProfileDataInvestmentExperienceToJSON = exports.investorProfileDataInvestmentExperienceFromJSON = exports.employmentDataEmploymentStatusToJSON = exports.employmentDataEmploymentStatusFromJSON = exports.instrumentSourceToJSON = exports.instrumentSourceFromJSON = exports.instrumentRiskToJSON = exports.instrumentRiskFromJSON = exports.instrumentStatusToJSON = exports.instrumentStatusFromJSON = exports.instrumentTypeToJSON = exports.instrumentTypeFromJSON = exports.stockGraduationStatusToJSON = exports.stockGraduationStatusFromJSON = exports.assetTransferStatusToJSON = void 0;
const amount_1 = require("../common/amount");
const image_1 = require("../common/image");
const legal_name_1 = require("../common/legal-name");
const protobufPackage = 'com.step.stock.proto';
var StockErrorCode;
(function (StockErrorCode) {
    StockErrorCode["INVALID_STOCK_ERROR_CODE"] = "INVALID_STOCK_ERROR_CODE";
    StockErrorCode["INSTRUMENT_NOT_FOUND"] = "INSTRUMENT_NOT_FOUND";
    StockErrorCode["INVALID_COMPRESSION_VALUE"] = "INVALID_COMPRESSION_VALUE";
    StockErrorCode["INVALID_PRICE_DATA"] = "INVALID_PRICE_DATA";
    StockErrorCode["ENROLLMENT_REQUIRED"] = "ENROLLMENT_REQUIRED";
    StockErrorCode["ORDER_NOT_FOUND"] = "ORDER_NOT_FOUND";
    StockErrorCode["INVALID_ORDER"] = "INVALID_ORDER";
    StockErrorCode["CHART_DATA_THROTTLED"] = "CHART_DATA_THROTTLED";
    StockErrorCode["PATTERN_DAY_TRADER"] = "PATTERN_DAY_TRADER";
    StockErrorCode["PENDING_ORDER_ALREADY_EXISTS"] = "PENDING_ORDER_ALREADY_EXISTS";
    StockErrorCode["MINIMUM_BALANCE"] = "MINIMUM_BALANCE";
    StockErrorCode["QUOTE_NOT_FOUND"] = "QUOTE_NOT_FOUND";
    StockErrorCode["ASSETS_TRANSFER_FAILURE"] = "ASSETS_TRANSFER_FAILURE";
    StockErrorCode["INVALID_ADDRESS"] = "INVALID_ADDRESS";
    StockErrorCode["INVALID_EMAIL"] = "INVALID_EMAIL";
    StockErrorCode["UNRECOGNIZED"] = "UNRECOGNIZED";
})(StockErrorCode || (exports.StockErrorCode = StockErrorCode = {}));
var PortfolioRiskLevel;
(function (PortfolioRiskLevel) {
    PortfolioRiskLevel["INVALID_RISK_LEVEL"] = "INVALID_RISK_LEVEL";
    PortfolioRiskLevel["CONSERVATIVE"] = "CONSERVATIVE";
    PortfolioRiskLevel["MODERATE"] = "MODERATE";
    PortfolioRiskLevel["AGGRESSIVE"] = "AGGRESSIVE";
    PortfolioRiskLevel["UNRECOGNIZED"] = "UNRECOGNIZED";
})(PortfolioRiskLevel || (exports.PortfolioRiskLevel = PortfolioRiskLevel = {}));
var EnrollmentStatus;
(function (EnrollmentStatus) {
    EnrollmentStatus["INVALID_ENROLLMENT_STATUS"] = "INVALID_ENROLLMENT_STATUS";
    EnrollmentStatus["ACTIVE"] = "ACTIVE";
    EnrollmentStatus["ENROLLED"] = "ENROLLED";
    EnrollmentStatus["CLOSED"] = "CLOSED";
    EnrollmentStatus["SELL_ONLY"] = "SELL_ONLY";
    EnrollmentStatus["OPEN_NO_NEW_TRADES"] = "OPEN_NO_NEW_TRADES";
    EnrollmentStatus["GRADUATED"] = "GRADUATED";
    EnrollmentStatus["UNRECOGNIZED"] = "UNRECOGNIZED";
})(EnrollmentStatus || (exports.EnrollmentStatus = EnrollmentStatus = {}));
/**
 * Whether an account can be closed.
 */
var AccountClosability;
(function (AccountClosability) {
    AccountClosability["INVALID_ACCOUNT_CLOSABILITY"] = "INVALID_ACCOUNT_CLOSABILITY";
    AccountClosability["CLOSABLE"] = "CLOSABLE";
    AccountClosability["BALANCE_NOT_ZERO"] = "BALANCE_NOT_ZERO";
    AccountClosability["OPEN_POSITIONS"] = "OPEN_POSITIONS";
    AccountClosability["PENDING_ORDERS"] = "PENDING_ORDERS";
    AccountClosability["PENDING_ASSET_TRANSFERS"] = "PENDING_ASSET_TRANSFERS";
    AccountClosability["DEPENDENT_ACCOUNT"] = "DEPENDENT_ACCOUNT";
    AccountClosability["UNRECOGNIZED"] = "UNRECOGNIZED";
})(AccountClosability || (exports.AccountClosability = AccountClosability = {}));
var AssetTransferStatus;
(function (AssetTransferStatus) {
    AssetTransferStatus["INVALID_ASSET_TRANSFER_STATUS"] = "INVALID_ASSET_TRANSFER_STATUS";
    AssetTransferStatus["ASSET_TRANSFER_STARTED"] = "ASSET_TRANSFER_STARTED";
    AssetTransferStatus["ASSET_TRANSFER_PENDING"] = "ASSET_TRANSFER_PENDING";
    AssetTransferStatus["ASSET_TRANSFER_COMPLETED"] = "ASSET_TRANSFER_COMPLETED";
    AssetTransferStatus["ASSET_TRANSFER_ON_HOLD"] = "ASSET_TRANSFER_ON_HOLD";
    AssetTransferStatus["ASSET_TRANSFER_FAILED"] = "ASSET_TRANSFER_FAILED";
    AssetTransferStatus["UNRECOGNIZED"] = "UNRECOGNIZED";
})(AssetTransferStatus || (exports.AssetTransferStatus = AssetTransferStatus = {}));
var StockGraduationStatus;
(function (StockGraduationStatus) {
    StockGraduationStatus["INVALID_STOCK_GRADUATION_STATUS"] = "INVALID_STOCK_GRADUATION_STATUS";
    StockGraduationStatus["PENDING"] = "PENDING";
    StockGraduationStatus["COMPLETED"] = "COMPLETED";
    StockGraduationStatus["ON_HOLD"] = "ON_HOLD";
    StockGraduationStatus["FAILED"] = "FAILED";
    StockGraduationStatus["UNRECOGNIZED"] = "UNRECOGNIZED";
})(StockGraduationStatus || (exports.StockGraduationStatus = StockGraduationStatus = {}));
var InstrumentType;
(function (InstrumentType) {
    InstrumentType["INVALID_INSTRUMENT_TYPE"] = "INVALID_INSTRUMENT_TYPE";
    InstrumentType["EQUITY"] = "EQUITY";
    InstrumentType["ETF"] = "ETF";
    InstrumentType["ADR"] = "ADR";
    InstrumentType["ETN"] = "ETN";
    InstrumentType["ALTERNATIVE_ASSET"] = "ALTERNATIVE_ASSET";
    InstrumentType["CRYPTO"] = "CRYPTO";
    InstrumentType["MUTUAL_FUND"] = "MUTUAL_FUND";
    InstrumentType["OPTIONS"] = "OPTIONS";
    InstrumentType["UNRECOGNIZED"] = "UNRECOGNIZED";
})(InstrumentType || (exports.InstrumentType = InstrumentType = {}));
var InstrumentStatus;
(function (InstrumentStatus) {
    InstrumentStatus["INVALID_INSTRUMENT_STATUS"] = "INVALID_INSTRUMENT_STATUS";
    InstrumentStatus["INSTRUMENT_ACTIVE"] = "INSTRUMENT_ACTIVE";
    InstrumentStatus["INSTRUMENT_INACTIVE"] = "INSTRUMENT_INACTIVE";
    InstrumentStatus["INSTRUMENT_CLOSE_ONLY"] = "INSTRUMENT_CLOSE_ONLY";
    InstrumentStatus["INSTRUMENT_HALTED"] = "INSTRUMENT_HALTED";
    InstrumentStatus["UNRECOGNIZED"] = "UNRECOGNIZED";
})(InstrumentStatus || (exports.InstrumentStatus = InstrumentStatus = {}));
var InstrumentRisk;
(function (InstrumentRisk) {
    InstrumentRisk["INVALID_INSTRUMENT_RISK"] = "INVALID_INSTRUMENT_RISK";
    InstrumentRisk["RISK_HIGH"] = "RISK_HIGH";
    InstrumentRisk["RISK_MEDIUM"] = "RISK_MEDIUM";
    InstrumentRisk["RISK_LOW"] = "RISK_LOW";
    InstrumentRisk["UNRECOGNIZED"] = "UNRECOGNIZED";
})(InstrumentRisk || (exports.InstrumentRisk = InstrumentRisk = {}));
var InstrumentSource;
(function (InstrumentSource) {
    InstrumentSource["INVALID_INSTRUMENT_SOURCE"] = "INVALID_INSTRUMENT_SOURCE";
    InstrumentSource["SOURCE_STEP"] = "SOURCE_STEP";
    InstrumentSource["SOURCE_DRIVE_WEALTH"] = "SOURCE_DRIVE_WEALTH";
    InstrumentSource["UNRECOGNIZED"] = "UNRECOGNIZED";
})(InstrumentSource || (exports.InstrumentSource = InstrumentSource = {}));
var EmploymentDataEmploymentStatus;
(function (EmploymentDataEmploymentStatus) {
    EmploymentDataEmploymentStatus["INVALID_EMPLOYMENT_STATUS"] = "INVALID_EMPLOYMENT_STATUS";
    EmploymentDataEmploymentStatus["EMPLOYED"] = "EMPLOYED";
    EmploymentDataEmploymentStatus["RETIRED"] = "RETIRED";
    EmploymentDataEmploymentStatus["STUDENT"] = "STUDENT";
    EmploymentDataEmploymentStatus["UNEMPLOYED"] = "UNEMPLOYED";
    EmploymentDataEmploymentStatus["SELF_EMPLOYED"] = "SELF_EMPLOYED";
    EmploymentDataEmploymentStatus["UNRECOGNIZED"] = "UNRECOGNIZED";
})(EmploymentDataEmploymentStatus || (exports.EmploymentDataEmploymentStatus = EmploymentDataEmploymentStatus = {}));
var InvestorProfileDataInvestmentExperience;
(function (InvestorProfileDataInvestmentExperience) {
    InvestorProfileDataInvestmentExperience["INVALID_INVESTMENT_EXPERIENCE"] = "INVALID_INVESTMENT_EXPERIENCE";
    InvestorProfileDataInvestmentExperience["NONE"] = "NONE";
    InvestorProfileDataInvestmentExperience["YRS_1_2"] = "YRS_1_2";
    InvestorProfileDataInvestmentExperience["YRS_3_5"] = "YRS_3_5";
    InvestorProfileDataInvestmentExperience["YRS_5_10"] = "YRS_5_10";
    InvestorProfileDataInvestmentExperience["YRS_10_PLUS"] = "YRS_10_PLUS";
    InvestorProfileDataInvestmentExperience["UNRECOGNIZED"] = "UNRECOGNIZED";
})(InvestorProfileDataInvestmentExperience || (exports.InvestorProfileDataInvestmentExperience = InvestorProfileDataInvestmentExperience = {}));
var InvestorProfileDataRiskTolerance;
(function (InvestorProfileDataRiskTolerance) {
    InvestorProfileDataRiskTolerance["INVALID_RISK_TOLERANCE"] = "INVALID_RISK_TOLERANCE";
    InvestorProfileDataRiskTolerance["LOW"] = "LOW";
    InvestorProfileDataRiskTolerance["MODERATE"] = "MODERATE";
    InvestorProfileDataRiskTolerance["SPECULATION"] = "SPECULATION";
    InvestorProfileDataRiskTolerance["HIGH"] = "HIGH";
    InvestorProfileDataRiskTolerance["UNRECOGNIZED"] = "UNRECOGNIZED";
})(InvestorProfileDataRiskTolerance || (exports.InvestorProfileDataRiskTolerance = InvestorProfileDataRiskTolerance = {}));
var InvestorProfileDataInvestmentObjective;
(function (InvestorProfileDataInvestmentObjective) {
    InvestorProfileDataInvestmentObjective["INVALID_INVESTMENT_OBJECTIVE"] = "INVALID_INVESTMENT_OBJECTIVE";
    InvestorProfileDataInvestmentObjective["LONG_TERM"] = "LONG_TERM";
    InvestorProfileDataInvestmentObjective["INFREQUENT"] = "INFREQUENT";
    InvestorProfileDataInvestmentObjective["FREQUENT"] = "FREQUENT";
    InvestorProfileDataInvestmentObjective["ACTIVE_DAILY"] = "ACTIVE_DAILY";
    InvestorProfileDataInvestmentObjective["NEW"] = "NEW";
    InvestorProfileDataInvestmentObjective["UNRECOGNIZED"] = "UNRECOGNIZED";
})(InvestorProfileDataInvestmentObjective || (exports.InvestorProfileDataInvestmentObjective = InvestorProfileDataInvestmentObjective = {}));
var EquityQuoteMarketCondition;
(function (EquityQuoteMarketCondition) {
    EquityQuoteMarketCondition["INVALID_MARKET_CONDITION"] = "INVALID_MARKET_CONDITION";
    /**
     * NORMAL - Symbol is trading normally
     */
    EquityQuoteMarketCondition["NORMAL"] = "NORMAL";
    /**
     * TRADING_HALT - Symbol is currently halted
     */
    EquityQuoteMarketCondition["TRADING_HALT"] = "TRADING_HALT";
    /**
     * UNKNOWN - Symbol has been placed on a restricted tag
     */
    EquityQuoteMarketCondition["UNKNOWN"] = "UNKNOWN";
    EquityQuoteMarketCondition["UNRECOGNIZED"] = "UNRECOGNIZED";
})(EquityQuoteMarketCondition || (exports.EquityQuoteMarketCondition = EquityQuoteMarketCondition = {}));
function createBaseIdentificationData() {
    return { citizenship: '' };
}
exports.IdentificationData = {
    fromJSON(object) {
        const message = {
            citizenship: isSet(object.citizenship) ? globalThis.String(object.citizenship) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.citizenship !== '') {
            obj.citizenship = message.citizenship;
        }
        return obj;
    },
    create(base) {
        return exports.IdentificationData.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseIdentificationData();
        message.citizenship = object.citizenship ?? '';
        return message;
    },
};
function createBasePersonalData() {
    return { politicallyExposedNames: [] };
}
exports.PersonalData = {
    fromJSON(object) {
        const message = {};
        if (globalThis.Array.isArray(object?.politicallyExposedNames)) {
            message.politicallyExposedNames = object.politicallyExposedNames.map((e) => globalThis.String(e));
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.politicallyExposedNames?.length) {
            obj.politicallyExposedNames = message.politicallyExposedNames;
        }
        return obj;
    },
    create(base) {
        return exports.PersonalData.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePersonalData();
        message.politicallyExposedNames = object.politicallyExposedNames?.map((e) => e) || [];
        return message;
    },
};
function createBaseEmploymentData() {
    return {
        status: EmploymentDataEmploymentStatus.INVALID_EMPLOYMENT_STATUS,
        employment: undefined,
        brokerDealerAffiliated: false,
        directorOf: undefined,
    };
}
exports.EmploymentData = {
    fromJSON(object) {
        const message = {
            status: isSet(object.status)
                ? employmentDataEmploymentStatusFromJSON(object.status)
                : EmploymentDataEmploymentStatus.INVALID_EMPLOYMENT_STATUS,
        };
        if (isSet(object.employment)) {
            message.employment = exports.EmploymentDataEmployment.fromJSON(object.employment);
        }
        if (isSet(object.brokerDealerAffiliated)) {
            message.brokerDealerAffiliated = globalThis.Boolean(object.brokerDealerAffiliated);
        }
        if (isSet(object.directorOf)) {
            message.directorOf = exports.EmploymentDataPublicCompany.fromJSON(object.directorOf);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.status !== EmploymentDataEmploymentStatus.INVALID_EMPLOYMENT_STATUS) {
            obj.status = employmentDataEmploymentStatusToJSON(message.status);
        }
        if (message.employment !== undefined) {
            obj.employment = exports.EmploymentDataEmployment.toJSON(message.employment);
        }
        if (message.brokerDealerAffiliated !== undefined && message.brokerDealerAffiliated !== false) {
            obj.brokerDealerAffiliated = message.brokerDealerAffiliated;
        }
        if (message.directorOf !== undefined) {
            obj.directorOf = exports.EmploymentDataPublicCompany.toJSON(message.directorOf);
        }
        return obj;
    },
    create(base) {
        return exports.EmploymentData.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseEmploymentData();
        message.status = object.status ?? EmploymentDataEmploymentStatus.INVALID_EMPLOYMENT_STATUS;
        message.employment = (object.employment !== undefined && object.employment !== null)
            ? exports.EmploymentDataEmployment.fromPartial(object.employment)
            : undefined;
        message.brokerDealerAffiliated = object.brokerDealerAffiliated ?? false;
        message.directorOf = (object.directorOf !== undefined && object.directorOf !== null)
            ? exports.EmploymentDataPublicCompany.fromPartial(object.directorOf)
            : undefined;
        return message;
    },
};
function createBaseEmploymentDataEmployment() {
    return { companyName: '', industry: '' };
}
exports.EmploymentDataEmployment = {
    fromJSON(object) {
        const message = {
            companyName: isSet(object.companyName) ? globalThis.String(object.companyName) : '',
            industry: isSet(object.industry) ? globalThis.String(object.industry) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.companyName !== '') {
            obj.companyName = message.companyName;
        }
        if (message.industry !== '') {
            obj.industry = message.industry;
        }
        return obj;
    },
    create(base) {
        return exports.EmploymentDataEmployment.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseEmploymentDataEmployment();
        message.companyName = object.companyName ?? '';
        message.industry = object.industry ?? '';
        return message;
    },
};
function createBaseEmploymentDataPublicCompany() {
    return { companyName: '', tickerSymbol: '' };
}
exports.EmploymentDataPublicCompany = {
    fromJSON(object) {
        const message = {
            companyName: isSet(object.companyName) ? globalThis.String(object.companyName) : '',
            tickerSymbol: isSet(object.tickerSymbol) ? globalThis.String(object.tickerSymbol) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.companyName !== '') {
            obj.companyName = message.companyName;
        }
        if (message.tickerSymbol !== '') {
            obj.tickerSymbol = message.tickerSymbol;
        }
        return obj;
    },
    create(base) {
        return exports.EmploymentDataPublicCompany.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseEmploymentDataPublicCompany();
        message.companyName = object.companyName ?? '';
        message.tickerSymbol = object.tickerSymbol ?? '';
        return message;
    },
};
function createBaseInvestorProfileData() {
    return {
        annualIncome: amount_1.Amount.fromPartial({}),
        networthTotal: amount_1.Amount.fromPartial({}),
        networthLiquid: undefined,
        riskTolerance: InvestorProfileDataRiskTolerance.INVALID_RISK_TOLERANCE,
        investmentExperience: InvestorProfileDataInvestmentExperience.INVALID_INVESTMENT_EXPERIENCE,
        investmentObjective: InvestorProfileDataInvestmentObjective.INVALID_INVESTMENT_OBJECTIVE,
    };
}
exports.InvestorProfileData = {
    fromJSON(object) {
        const message = {
            annualIncome: isSet(object.annualIncome)
                ? amount_1.Amount.fromJSON(object.annualIncome)
                : amount_1.Amount.fromPartial({}),
            networthTotal: isSet(object.networthTotal)
                ? amount_1.Amount.fromJSON(object.networthTotal)
                : amount_1.Amount.fromPartial({}),
        };
        if (isSet(object.networthLiquid)) {
            message.networthLiquid = amount_1.Amount.fromJSON(object.networthLiquid);
        }
        if (isSet(object.riskTolerance)) {
            message.riskTolerance = investorProfileDataRiskToleranceFromJSON(object.riskTolerance);
        }
        if (isSet(object.investmentExperience)) {
            message.investmentExperience = investorProfileDataInvestmentExperienceFromJSON(object.investmentExperience);
        }
        if (isSet(object.investmentObjective)) {
            message.investmentObjective = investorProfileDataInvestmentObjectiveFromJSON(object.investmentObjective);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.annualIncome !== undefined) {
            obj.annualIncome = amount_1.Amount.toJSON(message.annualIncome);
        }
        if (message.networthTotal !== undefined) {
            obj.networthTotal = amount_1.Amount.toJSON(message.networthTotal);
        }
        if (message.networthLiquid !== undefined) {
            obj.networthLiquid = amount_1.Amount.toJSON(message.networthLiquid);
        }
        if (message.riskTolerance !== undefined &&
            message.riskTolerance !== InvestorProfileDataRiskTolerance.INVALID_RISK_TOLERANCE) {
            obj.riskTolerance = investorProfileDataRiskToleranceToJSON(message.riskTolerance);
        }
        if (message.investmentExperience !== undefined &&
            message.investmentExperience !==
                InvestorProfileDataInvestmentExperience.INVALID_INVESTMENT_EXPERIENCE) {
            obj.investmentExperience = investorProfileDataInvestmentExperienceToJSON(message.investmentExperience);
        }
        if (message.investmentObjective !== undefined &&
            message.investmentObjective !==
                InvestorProfileDataInvestmentObjective.INVALID_INVESTMENT_OBJECTIVE) {
            obj.investmentObjective = investorProfileDataInvestmentObjectiveToJSON(message.investmentObjective);
        }
        return obj;
    },
    create(base) {
        return exports.InvestorProfileData.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseInvestorProfileData();
        message.annualIncome = (object.annualIncome !== undefined && object.annualIncome !== null)
            ? amount_1.Amount.fromPartial(object.annualIncome)
            : amount_1.Amount.fromPartial({});
        message.networthTotal = (object.networthTotal !== undefined && object.networthTotal !== null)
            ? amount_1.Amount.fromPartial(object.networthTotal)
            : amount_1.Amount.fromPartial({});
        message.networthLiquid = (object.networthLiquid !== undefined && object.networthLiquid !== null)
            ? amount_1.Amount.fromPartial(object.networthLiquid)
            : undefined;
        message.riskTolerance = object.riskTolerance ??
            InvestorProfileDataRiskTolerance.INVALID_RISK_TOLERANCE;
        message.investmentExperience = object.investmentExperience ??
            InvestorProfileDataInvestmentExperience.INVALID_INVESTMENT_EXPERIENCE;
        message.investmentObjective = object.investmentObjective ??
            InvestorProfileDataInvestmentObjective.INVALID_INVESTMENT_OBJECTIVE;
        return message;
    },
};
function createBaseEnrollment() {
    return {
        status: EnrollmentStatus.INVALID_ENROLLMENT_STATUS,
        createdAtMs: '0',
        accountNumber: '',
        graduationStatus: StockGraduationStatus.INVALID_STOCK_GRADUATION_STATUS,
    };
}
exports.Enrollment = {
    fromJSON(object) {
        const message = {
            status: isSet(object.status)
                ? enrollmentStatusFromJSON(object.status)
                : EnrollmentStatus.INVALID_ENROLLMENT_STATUS,
            createdAtMs: isSet(object.createdAtMs) ? globalThis.String(object.createdAtMs) : '0',
        };
        if (isSet(object.accountNumber)) {
            message.accountNumber = globalThis.String(object.accountNumber);
        }
        if (isSet(object.graduationStatus)) {
            message.graduationStatus = stockGraduationStatusFromJSON(object.graduationStatus);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.status !== EnrollmentStatus.INVALID_ENROLLMENT_STATUS) {
            obj.status = enrollmentStatusToJSON(message.status);
        }
        if (message.createdAtMs !== '0') {
            obj.createdAtMs = message.createdAtMs;
        }
        if (message.accountNumber !== undefined && message.accountNumber !== '') {
            obj.accountNumber = message.accountNumber;
        }
        if (message.graduationStatus !== undefined &&
            message.graduationStatus !== StockGraduationStatus.INVALID_STOCK_GRADUATION_STATUS) {
            obj.graduationStatus = stockGraduationStatusToJSON(message.graduationStatus);
        }
        return obj;
    },
    create(base) {
        return exports.Enrollment.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseEnrollment();
        message.status = object.status ?? EnrollmentStatus.INVALID_ENROLLMENT_STATUS;
        message.createdAtMs = object.createdAtMs ?? '0';
        message.accountNumber = object.accountNumber ?? '';
        message.graduationStatus = object.graduationStatus ??
            StockGraduationStatus.INVALID_STOCK_GRADUATION_STATUS;
        return message;
    },
};
function createBaseEquityPosition() {
    return {
        instrumentId: '',
        symbol: '',
        openQty: '',
        availableForTradingQty: '',
        marketValue: amount_1.Amount.fromPartial({}),
        costBasis: amount_1.Amount.fromPartial({}),
        averagePrice: amount_1.Amount.fromPartial({}),
        priorClosePrice: amount_1.Amount.fromPartial({}),
        marketPrice: amount_1.Amount.fromPartial({}),
        unrealizedPl: amount_1.Amount.fromPartial({}),
        unrealizedPlPct: '',
        unrealizedDayPl: amount_1.Amount.fromPartial({}),
        unrealizedDayPlPct: '',
    };
}
exports.EquityPosition = {
    fromJSON(object) {
        const message = {
            instrumentId: isSet(object.instrumentId) ? globalThis.String(object.instrumentId) : '',
            symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
            openQty: isSet(object.openQty) ? globalThis.String(object.openQty) : '',
            availableForTradingQty: isSet(object.availableForTradingQty)
                ? globalThis.String(object.availableForTradingQty)
                : '',
            marketValue: isSet(object.marketValue)
                ? amount_1.Amount.fromJSON(object.marketValue)
                : amount_1.Amount.fromPartial({}),
            costBasis: isSet(object.costBasis)
                ? amount_1.Amount.fromJSON(object.costBasis)
                : amount_1.Amount.fromPartial({}),
            averagePrice: isSet(object.averagePrice)
                ? amount_1.Amount.fromJSON(object.averagePrice)
                : amount_1.Amount.fromPartial({}),
            priorClosePrice: isSet(object.priorClosePrice)
                ? amount_1.Amount.fromJSON(object.priorClosePrice)
                : amount_1.Amount.fromPartial({}),
            marketPrice: isSet(object.marketPrice)
                ? amount_1.Amount.fromJSON(object.marketPrice)
                : amount_1.Amount.fromPartial({}),
            unrealizedPl: isSet(object.unrealizedPl)
                ? amount_1.Amount.fromJSON(object.unrealizedPl)
                : amount_1.Amount.fromPartial({}),
            unrealizedPlPct: isSet(object.unrealizedPlPct)
                ? globalThis.String(object.unrealizedPlPct)
                : '',
            unrealizedDayPl: isSet(object.unrealizedDayPl)
                ? amount_1.Amount.fromJSON(object.unrealizedDayPl)
                : amount_1.Amount.fromPartial({}),
            unrealizedDayPlPct: isSet(object.unrealizedDayPlPct)
                ? globalThis.String(object.unrealizedDayPlPct)
                : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.instrumentId !== '') {
            obj.instrumentId = message.instrumentId;
        }
        if (message.symbol !== '') {
            obj.symbol = message.symbol;
        }
        if (message.openQty !== '') {
            obj.openQty = message.openQty;
        }
        if (message.availableForTradingQty !== '') {
            obj.availableForTradingQty = message.availableForTradingQty;
        }
        if (message.marketValue !== undefined) {
            obj.marketValue = amount_1.Amount.toJSON(message.marketValue);
        }
        if (message.costBasis !== undefined) {
            obj.costBasis = amount_1.Amount.toJSON(message.costBasis);
        }
        if (message.averagePrice !== undefined) {
            obj.averagePrice = amount_1.Amount.toJSON(message.averagePrice);
        }
        if (message.priorClosePrice !== undefined) {
            obj.priorClosePrice = amount_1.Amount.toJSON(message.priorClosePrice);
        }
        if (message.marketPrice !== undefined) {
            obj.marketPrice = amount_1.Amount.toJSON(message.marketPrice);
        }
        if (message.unrealizedPl !== undefined) {
            obj.unrealizedPl = amount_1.Amount.toJSON(message.unrealizedPl);
        }
        if (message.unrealizedPlPct !== '') {
            obj.unrealizedPlPct = message.unrealizedPlPct;
        }
        if (message.unrealizedDayPl !== undefined) {
            obj.unrealizedDayPl = amount_1.Amount.toJSON(message.unrealizedDayPl);
        }
        if (message.unrealizedDayPlPct !== '') {
            obj.unrealizedDayPlPct = message.unrealizedDayPlPct;
        }
        return obj;
    },
    create(base) {
        return exports.EquityPosition.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseEquityPosition();
        message.instrumentId = object.instrumentId ?? '';
        message.symbol = object.symbol ?? '';
        message.openQty = object.openQty ?? '';
        message.availableForTradingQty = object.availableForTradingQty ?? '';
        message.marketValue = (object.marketValue !== undefined && object.marketValue !== null)
            ? amount_1.Amount.fromPartial(object.marketValue)
            : amount_1.Amount.fromPartial({});
        message.costBasis = (object.costBasis !== undefined && object.costBasis !== null)
            ? amount_1.Amount.fromPartial(object.costBasis)
            : amount_1.Amount.fromPartial({});
        message.averagePrice = (object.averagePrice !== undefined && object.averagePrice !== null)
            ? amount_1.Amount.fromPartial(object.averagePrice)
            : amount_1.Amount.fromPartial({});
        message.priorClosePrice =
            (object.priorClosePrice !== undefined && object.priorClosePrice !== null)
                ? amount_1.Amount.fromPartial(object.priorClosePrice)
                : amount_1.Amount.fromPartial({});
        message.marketPrice = (object.marketPrice !== undefined && object.marketPrice !== null)
            ? amount_1.Amount.fromPartial(object.marketPrice)
            : amount_1.Amount.fromPartial({});
        message.unrealizedPl = (object.unrealizedPl !== undefined && object.unrealizedPl !== null)
            ? amount_1.Amount.fromPartial(object.unrealizedPl)
            : amount_1.Amount.fromPartial({});
        message.unrealizedPlPct = object.unrealizedPlPct ?? '';
        message.unrealizedDayPl =
            (object.unrealizedDayPl !== undefined && object.unrealizedDayPl !== null)
                ? amount_1.Amount.fromPartial(object.unrealizedDayPl)
                : amount_1.Amount.fromPartial({});
        message.unrealizedDayPlPct = object.unrealizedDayPlPct ?? '';
        return message;
    },
};
function createBaseAccountPositions() {
    return {
        equityValue: amount_1.Amount.fromPartial({}),
        equityPositions: [],
        updatedAtMs: '0',
        unrealizedDayPl: amount_1.Amount.fromPartial({}),
        unrealizedDayPlPct: '',
        unrealizedPl: amount_1.Amount.fromPartial({}),
        unrealizedPlPct: '',
    };
}
exports.AccountPositions = {
    fromJSON(object) {
        const message = {
            equityValue: isSet(object.equityValue)
                ? amount_1.Amount.fromJSON(object.equityValue)
                : amount_1.Amount.fromPartial({}),
            equityPositions: globalThis.Array.isArray(object?.equityPositions)
                ? object.equityPositions.map((e) => exports.EquityPosition.fromJSON(e))
                : [],
            updatedAtMs: isSet(object.updatedAtMs) ? globalThis.String(object.updatedAtMs) : '0',
            unrealizedDayPl: isSet(object.unrealizedDayPl)
                ? amount_1.Amount.fromJSON(object.unrealizedDayPl)
                : amount_1.Amount.fromPartial({}),
            unrealizedDayPlPct: isSet(object.unrealizedDayPlPct)
                ? globalThis.String(object.unrealizedDayPlPct)
                : '',
            unrealizedPl: isSet(object.unrealizedPl)
                ? amount_1.Amount.fromJSON(object.unrealizedPl)
                : amount_1.Amount.fromPartial({}),
            unrealizedPlPct: isSet(object.unrealizedPlPct)
                ? globalThis.String(object.unrealizedPlPct)
                : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.equityValue !== undefined) {
            obj.equityValue = amount_1.Amount.toJSON(message.equityValue);
        }
        if (message.equityPositions?.length) {
            obj.equityPositions = message.equityPositions.map((e) => exports.EquityPosition.toJSON(e));
        }
        if (message.updatedAtMs !== '0') {
            obj.updatedAtMs = message.updatedAtMs;
        }
        if (message.unrealizedDayPl !== undefined) {
            obj.unrealizedDayPl = amount_1.Amount.toJSON(message.unrealizedDayPl);
        }
        if (message.unrealizedDayPlPct !== '') {
            obj.unrealizedDayPlPct = message.unrealizedDayPlPct;
        }
        if (message.unrealizedPl !== undefined) {
            obj.unrealizedPl = amount_1.Amount.toJSON(message.unrealizedPl);
        }
        if (message.unrealizedPlPct !== '') {
            obj.unrealizedPlPct = message.unrealizedPlPct;
        }
        return obj;
    },
    create(base) {
        return exports.AccountPositions.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAccountPositions();
        message.equityValue = (object.equityValue !== undefined && object.equityValue !== null)
            ? amount_1.Amount.fromPartial(object.equityValue)
            : amount_1.Amount.fromPartial({});
        message.equityPositions = object.equityPositions?.map((e) => exports.EquityPosition.fromPartial(e)) ||
            [];
        message.updatedAtMs = object.updatedAtMs ?? '0';
        message.unrealizedDayPl =
            (object.unrealizedDayPl !== undefined && object.unrealizedDayPl !== null)
                ? amount_1.Amount.fromPartial(object.unrealizedDayPl)
                : amount_1.Amount.fromPartial({});
        message.unrealizedDayPlPct = object.unrealizedDayPlPct ?? '';
        message.unrealizedPl = (object.unrealizedPl !== undefined && object.unrealizedPl !== null)
            ? amount_1.Amount.fromPartial(object.unrealizedPl)
            : amount_1.Amount.fromPartial({});
        message.unrealizedPlPct = object.unrealizedPlPct ?? '';
        return message;
    },
};
function createBasePrice() {
    return {
        priceAtMs: '0',
        open: amount_1.Amount.fromPartial({}),
        high: amount_1.Amount.fromPartial({}),
        low: amount_1.Amount.fromPartial({}),
        close: amount_1.Amount.fromPartial({}),
        volume: 0,
    };
}
exports.Price = {
    fromJSON(object) {
        const message = {
            priceAtMs: isSet(object.priceAtMs) ? globalThis.String(object.priceAtMs) : '0',
            open: isSet(object.open) ? amount_1.Amount.fromJSON(object.open) : amount_1.Amount.fromPartial({}),
            high: isSet(object.high) ? amount_1.Amount.fromJSON(object.high) : amount_1.Amount.fromPartial({}),
            low: isSet(object.low) ? amount_1.Amount.fromJSON(object.low) : amount_1.Amount.fromPartial({}),
            close: isSet(object.close) ? amount_1.Amount.fromJSON(object.close) : amount_1.Amount.fromPartial({}),
            volume: isSet(object.volume) ? globalThis.Number(object.volume) : 0,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.priceAtMs !== '0') {
            obj.priceAtMs = message.priceAtMs;
        }
        if (message.open !== undefined) {
            obj.open = amount_1.Amount.toJSON(message.open);
        }
        if (message.high !== undefined) {
            obj.high = amount_1.Amount.toJSON(message.high);
        }
        if (message.low !== undefined) {
            obj.low = amount_1.Amount.toJSON(message.low);
        }
        if (message.close !== undefined) {
            obj.close = amount_1.Amount.toJSON(message.close);
        }
        if (message.volume !== 0) {
            obj.volume = Math.round(message.volume);
        }
        return obj;
    },
    create(base) {
        return exports.Price.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePrice();
        message.priceAtMs = object.priceAtMs ?? '0';
        message.open = (object.open !== undefined && object.open !== null)
            ? amount_1.Amount.fromPartial(object.open)
            : amount_1.Amount.fromPartial({});
        message.high = (object.high !== undefined && object.high !== null)
            ? amount_1.Amount.fromPartial(object.high)
            : amount_1.Amount.fromPartial({});
        message.low = (object.low !== undefined && object.low !== null)
            ? amount_1.Amount.fromPartial(object.low)
            : amount_1.Amount.fromPartial({});
        message.close = (object.close !== undefined && object.close !== null)
            ? amount_1.Amount.fromPartial(object.close)
            : amount_1.Amount.fromPartial({});
        message.volume = object.volume ?? 0;
        return message;
    },
};
function createBaseInstrumentCategory() {
    return {
        id: '',
        title: '',
        description: '',
        image: image_1.Image.fromPartial({}),
        methodology: exports.InstrumentCategoryMethodology.fromPartial({}),
    };
}
exports.InstrumentCategory = {
    fromJSON(object) {
        const message = {
            id: isSet(object.id) ? globalThis.String(object.id) : '',
            title: isSet(object.title) ? globalThis.String(object.title) : '',
            description: isSet(object.description) ? globalThis.String(object.description) : '',
            image: isSet(object.image) ? image_1.Image.fromJSON(object.image) : image_1.Image.fromPartial({}),
            methodology: isSet(object.methodology)
                ? exports.InstrumentCategoryMethodology.fromJSON(object.methodology)
                : exports.InstrumentCategoryMethodology.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== '') {
            obj.id = message.id;
        }
        if (message.title !== '') {
            obj.title = message.title;
        }
        if (message.description !== '') {
            obj.description = message.description;
        }
        if (message.image !== undefined) {
            obj.image = image_1.Image.toJSON(message.image);
        }
        if (message.methodology !== undefined) {
            obj.methodology = exports.InstrumentCategoryMethodology.toJSON(message.methodology);
        }
        return obj;
    },
    create(base) {
        return exports.InstrumentCategory.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseInstrumentCategory();
        message.id = object.id ?? '';
        message.title = object.title ?? '';
        message.description = object.description ?? '';
        message.image = (object.image !== undefined && object.image !== null)
            ? image_1.Image.fromPartial(object.image)
            : image_1.Image.fromPartial({});
        message.methodology = (object.methodology !== undefined && object.methodology !== null)
            ? exports.InstrumentCategoryMethodology.fromPartial(object.methodology)
            : exports.InstrumentCategoryMethodology.fromPartial({});
        return message;
    },
};
function createBaseInstrumentCategoryMethodology() {
    return { title: '', description: '' };
}
exports.InstrumentCategoryMethodology = {
    fromJSON(object) {
        const message = {
            title: isSet(object.title) ? globalThis.String(object.title) : '',
            description: isSet(object.description) ? globalThis.String(object.description) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.title !== '') {
            obj.title = message.title;
        }
        if (message.description !== '') {
            obj.description = message.description;
        }
        return obj;
    },
    create(base) {
        return exports.InstrumentCategoryMethodology.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseInstrumentCategoryMethodology();
        message.title = object.title ?? '';
        message.description = object.description ?? '';
        return message;
    },
};
function createBaseRestriction() {
    return { restrictedAt: '0', prevStatus: EnrollmentStatus.INVALID_ENROLLMENT_STATUS };
}
exports.Restriction = {
    fromJSON(object) {
        const message = {
            restrictedAt: isSet(object.restrictedAt) ? globalThis.String(object.restrictedAt) : '0',
            prevStatus: isSet(object.prevStatus)
                ? enrollmentStatusFromJSON(object.prevStatus)
                : EnrollmentStatus.INVALID_ENROLLMENT_STATUS,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.restrictedAt !== '0') {
            obj.restrictedAt = message.restrictedAt;
        }
        if (message.prevStatus !== EnrollmentStatus.INVALID_ENROLLMENT_STATUS) {
            obj.prevStatus = enrollmentStatusToJSON(message.prevStatus);
        }
        return obj;
    },
    create(base) {
        return exports.Restriction.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRestriction();
        message.restrictedAt = object.restrictedAt ?? '0';
        message.prevStatus = object.prevStatus ?? EnrollmentStatus.INVALID_ENROLLMENT_STATUS;
        return message;
    },
};
function createBaseExternalAccountData() {
    return { restriction: undefined, legalName: undefined };
}
exports.ExternalAccountData = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.restriction)) {
            message.restriction = exports.Restriction.fromJSON(object.restriction);
        }
        if (isSet(object.legalName)) {
            message.legalName = legal_name_1.LegalName.fromJSON(object.legalName);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.restriction !== undefined) {
            obj.restriction = exports.Restriction.toJSON(message.restriction);
        }
        if (message.legalName !== undefined) {
            obj.legalName = legal_name_1.LegalName.toJSON(message.legalName);
        }
        return obj;
    },
    create(base) {
        return exports.ExternalAccountData.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseExternalAccountData();
        message.restriction = (object.restriction !== undefined && object.restriction !== null)
            ? exports.Restriction.fromPartial(object.restriction)
            : undefined;
        message.legalName = (object.legalName !== undefined && object.legalName !== null)
            ? legal_name_1.LegalName.fromPartial(object.legalName)
            : undefined;
        return message;
    },
};
function createBaseTradeViolation() {
    return {
        symbol: '',
        purchase: exports.TradeViolationTransaction.fromPartial({}),
        sales: [],
        createdAtMs: '0',
    };
}
exports.TradeViolation = {
    fromJSON(object) {
        const message = {
            symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
            purchase: isSet(object.purchase)
                ? exports.TradeViolationTransaction.fromJSON(object.purchase)
                : exports.TradeViolationTransaction.fromPartial({}),
            sales: globalThis.Array.isArray(object?.sales)
                ? object.sales.map((e) => exports.TradeViolationTransaction.fromJSON(e))
                : [],
            createdAtMs: isSet(object.createdAtMs) ? globalThis.String(object.createdAtMs) : '0',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.symbol !== '') {
            obj.symbol = message.symbol;
        }
        if (message.purchase !== undefined) {
            obj.purchase = exports.TradeViolationTransaction.toJSON(message.purchase);
        }
        if (message.sales?.length) {
            obj.sales = message.sales.map((e) => exports.TradeViolationTransaction.toJSON(e));
        }
        if (message.createdAtMs !== '0') {
            obj.createdAtMs = message.createdAtMs;
        }
        return obj;
    },
    create(base) {
        return exports.TradeViolation.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTradeViolation();
        message.symbol = object.symbol ?? '';
        message.purchase = (object.purchase !== undefined && object.purchase !== null)
            ? exports.TradeViolationTransaction.fromPartial(object.purchase)
            : exports.TradeViolationTransaction.fromPartial({});
        message.sales = object.sales?.map((e) => exports.TradeViolationTransaction.fromPartial(e)) || [];
        message.createdAtMs = object.createdAtMs ?? '0';
        return message;
    },
};
function createBaseTradeViolationTransaction() {
    return {
        paymentId: '',
        transactionId: '',
        quantity: '',
        amount: amount_1.Amount.fromPartial({}),
        createdAtMs: '0',
    };
}
exports.TradeViolationTransaction = {
    fromJSON(object) {
        const message = {
            paymentId: isSet(object.paymentId) ? globalThis.String(object.paymentId) : '',
            transactionId: isSet(object.transactionId) ? globalThis.String(object.transactionId) : '',
            quantity: isSet(object.quantity) ? globalThis.String(object.quantity) : '',
            amount: isSet(object.amount) ? amount_1.Amount.fromJSON(object.amount) : amount_1.Amount.fromPartial({}),
            createdAtMs: isSet(object.createdAtMs) ? globalThis.String(object.createdAtMs) : '0',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.paymentId !== '') {
            obj.paymentId = message.paymentId;
        }
        if (message.transactionId !== '') {
            obj.transactionId = message.transactionId;
        }
        if (message.quantity !== '') {
            obj.quantity = message.quantity;
        }
        if (message.amount !== undefined) {
            obj.amount = amount_1.Amount.toJSON(message.amount);
        }
        if (message.createdAtMs !== '0') {
            obj.createdAtMs = message.createdAtMs;
        }
        return obj;
    },
    create(base) {
        return exports.TradeViolationTransaction.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTradeViolationTransaction();
        message.paymentId = object.paymentId ?? '';
        message.transactionId = object.transactionId ?? '';
        message.quantity = object.quantity ?? '';
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? amount_1.Amount.fromPartial(object.amount)
            : amount_1.Amount.fromPartial({});
        message.createdAtMs = object.createdAtMs ?? '0';
        return message;
    },
};
function createBaseInstrumentsSearchResult() {
    return {
        symbol: '',
        name: '',
        status: InstrumentStatus.INVALID_INSTRUMENT_STATUS,
        type: InstrumentType.INVALID_INSTRUMENT_TYPE,
        risk: InstrumentRisk.INVALID_INSTRUMENT_RISK,
        logoUrl: '',
        categoryIds: [],
    };
}
exports.InstrumentsSearchResult = {
    fromJSON(object) {
        const message = {
            symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
            name: isSet(object.name) ? globalThis.String(object.name) : '',
            status: isSet(object.status)
                ? instrumentStatusFromJSON(object.status)
                : InstrumentStatus.INVALID_INSTRUMENT_STATUS,
            type: isSet(object.type)
                ? instrumentTypeFromJSON(object.type)
                : InstrumentType.INVALID_INSTRUMENT_TYPE,
            categoryIds: globalThis.Array.isArray(object?.categoryIds)
                ? object.categoryIds.map((e) => globalThis.String(e))
                : [],
        };
        if (isSet(object.risk)) {
            message.risk = instrumentRiskFromJSON(object.risk);
        }
        if (isSet(object.logoUrl)) {
            message.logoUrl = globalThis.String(object.logoUrl);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.symbol !== '') {
            obj.symbol = message.symbol;
        }
        if (message.name !== '') {
            obj.name = message.name;
        }
        if (message.status !== InstrumentStatus.INVALID_INSTRUMENT_STATUS) {
            obj.status = instrumentStatusToJSON(message.status);
        }
        if (message.type !== InstrumentType.INVALID_INSTRUMENT_TYPE) {
            obj.type = instrumentTypeToJSON(message.type);
        }
        if (message.risk !== undefined && message.risk !== InstrumentRisk.INVALID_INSTRUMENT_RISK) {
            obj.risk = instrumentRiskToJSON(message.risk);
        }
        if (message.logoUrl !== undefined && message.logoUrl !== '') {
            obj.logoUrl = message.logoUrl;
        }
        if (message.categoryIds?.length) {
            obj.categoryIds = message.categoryIds;
        }
        return obj;
    },
    create(base) {
        return exports.InstrumentsSearchResult.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseInstrumentsSearchResult();
        message.symbol = object.symbol ?? '';
        message.name = object.name ?? '';
        message.status = object.status ?? InstrumentStatus.INVALID_INSTRUMENT_STATUS;
        message.type = object.type ?? InstrumentType.INVALID_INSTRUMENT_TYPE;
        message.risk = object.risk ?? InstrumentRisk.INVALID_INSTRUMENT_RISK;
        message.logoUrl = object.logoUrl ?? '';
        message.categoryIds = object.categoryIds?.map((e) => e) || [];
        return message;
    },
};
function createBaseEquityQuote() {
    return {
        symbol: '',
        bid: amount_1.Amount.fromPartial({}),
        ask: amount_1.Amount.fromPartial({}),
        lastTrade: amount_1.Amount.fromPartial({}),
        change: undefined,
        open: amount_1.Amount.fromPartial({}),
        high: amount_1.Amount.fromPartial({}),
        low: amount_1.Amount.fromPartial({}),
        close: amount_1.Amount.fromPartial({}),
        priorClose: amount_1.Amount.fromPartial({}),
        volume: 0,
        marketCondition: EquityQuoteMarketCondition.INVALID_MARKET_CONDITION,
    };
}
exports.EquityQuote = {
    fromJSON(object) {
        const message = {
            symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
            bid: isSet(object.bid) ? amount_1.Amount.fromJSON(object.bid) : amount_1.Amount.fromPartial({}),
            ask: isSet(object.ask) ? amount_1.Amount.fromJSON(object.ask) : amount_1.Amount.fromPartial({}),
            lastTrade: isSet(object.lastTrade)
                ? amount_1.Amount.fromJSON(object.lastTrade)
                : amount_1.Amount.fromPartial({}),
            open: isSet(object.open) ? amount_1.Amount.fromJSON(object.open) : amount_1.Amount.fromPartial({}),
            high: isSet(object.high) ? amount_1.Amount.fromJSON(object.high) : amount_1.Amount.fromPartial({}),
            low: isSet(object.low) ? amount_1.Amount.fromJSON(object.low) : amount_1.Amount.fromPartial({}),
            close: isSet(object.close) ? amount_1.Amount.fromJSON(object.close) : amount_1.Amount.fromPartial({}),
            priorClose: isSet(object.priorClose)
                ? amount_1.Amount.fromJSON(object.priorClose)
                : amount_1.Amount.fromPartial({}),
            volume: isSet(object.volume) ? globalThis.Number(object.volume) : 0,
            marketCondition: isSet(object.marketCondition)
                ? equityQuoteMarketConditionFromJSON(object.marketCondition)
                : EquityQuoteMarketCondition.INVALID_MARKET_CONDITION,
        };
        if (isSet(object.change)) {
            message.change = amount_1.Amount.fromJSON(object.change);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.symbol !== '') {
            obj.symbol = message.symbol;
        }
        if (message.bid !== undefined) {
            obj.bid = amount_1.Amount.toJSON(message.bid);
        }
        if (message.ask !== undefined) {
            obj.ask = amount_1.Amount.toJSON(message.ask);
        }
        if (message.lastTrade !== undefined) {
            obj.lastTrade = amount_1.Amount.toJSON(message.lastTrade);
        }
        if (message.change !== undefined) {
            obj.change = amount_1.Amount.toJSON(message.change);
        }
        if (message.open !== undefined) {
            obj.open = amount_1.Amount.toJSON(message.open);
        }
        if (message.high !== undefined) {
            obj.high = amount_1.Amount.toJSON(message.high);
        }
        if (message.low !== undefined) {
            obj.low = amount_1.Amount.toJSON(message.low);
        }
        if (message.close !== undefined) {
            obj.close = amount_1.Amount.toJSON(message.close);
        }
        if (message.priorClose !== undefined) {
            obj.priorClose = amount_1.Amount.toJSON(message.priorClose);
        }
        if (message.volume !== 0) {
            obj.volume = Math.round(message.volume);
        }
        if (message.marketCondition !== EquityQuoteMarketCondition.INVALID_MARKET_CONDITION) {
            obj.marketCondition = equityQuoteMarketConditionToJSON(message.marketCondition);
        }
        return obj;
    },
    create(base) {
        return exports.EquityQuote.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseEquityQuote();
        message.symbol = object.symbol ?? '';
        message.bid = (object.bid !== undefined && object.bid !== null)
            ? amount_1.Amount.fromPartial(object.bid)
            : amount_1.Amount.fromPartial({});
        message.ask = (object.ask !== undefined && object.ask !== null)
            ? amount_1.Amount.fromPartial(object.ask)
            : amount_1.Amount.fromPartial({});
        message.lastTrade = (object.lastTrade !== undefined && object.lastTrade !== null)
            ? amount_1.Amount.fromPartial(object.lastTrade)
            : amount_1.Amount.fromPartial({});
        message.change = (object.change !== undefined && object.change !== null)
            ? amount_1.Amount.fromPartial(object.change)
            : undefined;
        message.open = (object.open !== undefined && object.open !== null)
            ? amount_1.Amount.fromPartial(object.open)
            : amount_1.Amount.fromPartial({});
        message.high = (object.high !== undefined && object.high !== null)
            ? amount_1.Amount.fromPartial(object.high)
            : amount_1.Amount.fromPartial({});
        message.low = (object.low !== undefined && object.low !== null)
            ? amount_1.Amount.fromPartial(object.low)
            : amount_1.Amount.fromPartial({});
        message.close = (object.close !== undefined && object.close !== null)
            ? amount_1.Amount.fromPartial(object.close)
            : amount_1.Amount.fromPartial({});
        message.priorClose = (object.priorClose !== undefined && object.priorClose !== null)
            ? amount_1.Amount.fromPartial(object.priorClose)
            : amount_1.Amount.fromPartial({});
        message.volume = object.volume ?? 0;
        message.marketCondition = object.marketCondition ??
            EquityQuoteMarketCondition.INVALID_MARKET_CONDITION;
        return message;
    },
};
function createBaseNbboQuote() {
    return {
        symbol: '',
        ask: exports.NbboQuoteQuote.fromPartial({}),
        bid: exports.NbboQuoteQuote.fromPartial({}),
        lastTrade: exports.NbboQuoteQuote.fromPartial({}),
        volume: 0,
        lastUpdatedAtMs: '0',
    };
}
exports.NbboQuote = {
    fromJSON(object) {
        const message = {
            symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
            ask: isSet(object.ask) ? exports.NbboQuoteQuote.fromJSON(object.ask) : exports.NbboQuoteQuote.fromPartial({}),
            bid: isSet(object.bid) ? exports.NbboQuoteQuote.fromJSON(object.bid) : exports.NbboQuoteQuote.fromPartial({}),
            lastTrade: isSet(object.lastTrade)
                ? exports.NbboQuoteQuote.fromJSON(object.lastTrade)
                : exports.NbboQuoteQuote.fromPartial({}),
            volume: isSet(object.volume) ? globalThis.Number(object.volume) : 0,
            lastUpdatedAtMs: isSet(object.lastUpdatedAtMs)
                ? globalThis.String(object.lastUpdatedAtMs)
                : '0',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.symbol !== '') {
            obj.symbol = message.symbol;
        }
        if (message.ask !== undefined) {
            obj.ask = exports.NbboQuoteQuote.toJSON(message.ask);
        }
        if (message.bid !== undefined) {
            obj.bid = exports.NbboQuoteQuote.toJSON(message.bid);
        }
        if (message.lastTrade !== undefined) {
            obj.lastTrade = exports.NbboQuoteQuote.toJSON(message.lastTrade);
        }
        if (message.volume !== 0) {
            obj.volume = Math.round(message.volume);
        }
        if (message.lastUpdatedAtMs !== '0') {
            obj.lastUpdatedAtMs = message.lastUpdatedAtMs;
        }
        return obj;
    },
    create(base) {
        return exports.NbboQuote.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseNbboQuote();
        message.symbol = object.symbol ?? '';
        message.ask = (object.ask !== undefined && object.ask !== null)
            ? exports.NbboQuoteQuote.fromPartial(object.ask)
            : exports.NbboQuoteQuote.fromPartial({});
        message.bid = (object.bid !== undefined && object.bid !== null)
            ? exports.NbboQuoteQuote.fromPartial(object.bid)
            : exports.NbboQuoteQuote.fromPartial({});
        message.lastTrade = (object.lastTrade !== undefined && object.lastTrade !== null)
            ? exports.NbboQuoteQuote.fromPartial(object.lastTrade)
            : exports.NbboQuoteQuote.fromPartial({});
        message.volume = object.volume ?? 0;
        message.lastUpdatedAtMs = object.lastUpdatedAtMs ?? '0';
        return message;
    },
};
function createBaseNbboQuoteQuote() {
    return { price: amount_1.Amount.fromPartial({}), exchange: '', size: 0 };
}
exports.NbboQuoteQuote = {
    fromJSON(object) {
        const message = {
            price: isSet(object.price) ? amount_1.Amount.fromJSON(object.price) : amount_1.Amount.fromPartial({}),
            exchange: isSet(object.exchange) ? globalThis.String(object.exchange) : '',
            size: isSet(object.size) ? globalThis.Number(object.size) : 0,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.price !== undefined) {
            obj.price = amount_1.Amount.toJSON(message.price);
        }
        if (message.exchange !== '') {
            obj.exchange = message.exchange;
        }
        if (message.size !== 0) {
            obj.size = Math.round(message.size);
        }
        return obj;
    },
    create(base) {
        return exports.NbboQuoteQuote.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseNbboQuoteQuote();
        message.price = (object.price !== undefined && object.price !== null)
            ? amount_1.Amount.fromPartial(object.price)
            : amount_1.Amount.fromPartial({});
        message.exchange = object.exchange ?? '';
        message.size = object.size ?? 0;
        return message;
    },
};
function createBaseOrderQuote() {
    return {
        price: amount_1.Amount.fromPartial({}),
        quantity: '',
        grossAmount: amount_1.Amount.fromPartial({}),
        fees: undefined,
        netAmount: amount_1.Amount.fromPartial({}),
        dayTrade: false,
    };
}
exports.OrderQuote = {
    fromJSON(object) {
        const message = {
            price: isSet(object.price) ? amount_1.Amount.fromJSON(object.price) : amount_1.Amount.fromPartial({}),
            quantity: isSet(object.quantity) ? globalThis.String(object.quantity) : '',
            grossAmount: isSet(object.grossAmount)
                ? amount_1.Amount.fromJSON(object.grossAmount)
                : amount_1.Amount.fromPartial({}),
            netAmount: isSet(object.netAmount)
                ? amount_1.Amount.fromJSON(object.netAmount)
                : amount_1.Amount.fromPartial({}),
            dayTrade: isSet(object.dayTrade) ? globalThis.Boolean(object.dayTrade) : false,
        };
        if (isSet(object.fees)) {
            message.fees = exports.OrderQuoteFees.fromJSON(object.fees);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.price !== undefined) {
            obj.price = amount_1.Amount.toJSON(message.price);
        }
        if (message.quantity !== '') {
            obj.quantity = message.quantity;
        }
        if (message.grossAmount !== undefined) {
            obj.grossAmount = amount_1.Amount.toJSON(message.grossAmount);
        }
        if (message.fees !== undefined) {
            obj.fees = exports.OrderQuoteFees.toJSON(message.fees);
        }
        if (message.netAmount !== undefined) {
            obj.netAmount = amount_1.Amount.toJSON(message.netAmount);
        }
        if (message.dayTrade !== false) {
            obj.dayTrade = message.dayTrade;
        }
        return obj;
    },
    create(base) {
        return exports.OrderQuote.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseOrderQuote();
        message.price = (object.price !== undefined && object.price !== null)
            ? amount_1.Amount.fromPartial(object.price)
            : amount_1.Amount.fromPartial({});
        message.quantity = object.quantity ?? '';
        message.grossAmount = (object.grossAmount !== undefined && object.grossAmount !== null)
            ? amount_1.Amount.fromPartial(object.grossAmount)
            : amount_1.Amount.fromPartial({});
        message.fees = (object.fees !== undefined && object.fees !== null)
            ? exports.OrderQuoteFees.fromPartial(object.fees)
            : undefined;
        message.netAmount = (object.netAmount !== undefined && object.netAmount !== null)
            ? amount_1.Amount.fromPartial(object.netAmount)
            : amount_1.Amount.fromPartial({});
        message.dayTrade = object.dayTrade ?? false;
        return message;
    },
};
function createBaseOrderQuoteFees() {
    return {
        secFee: amount_1.Amount.fromPartial({}),
        tafFee: amount_1.Amount.fromPartial({}),
        total: amount_1.Amount.fromPartial({}),
    };
}
exports.OrderQuoteFees = {
    fromJSON(object) {
        const message = {
            secFee: isSet(object.secFee) ? amount_1.Amount.fromJSON(object.secFee) : amount_1.Amount.fromPartial({}),
            tafFee: isSet(object.tafFee) ? amount_1.Amount.fromJSON(object.tafFee) : amount_1.Amount.fromPartial({}),
            total: isSet(object.total) ? amount_1.Amount.fromJSON(object.total) : amount_1.Amount.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.secFee !== undefined) {
            obj.secFee = amount_1.Amount.toJSON(message.secFee);
        }
        if (message.tafFee !== undefined) {
            obj.tafFee = amount_1.Amount.toJSON(message.tafFee);
        }
        if (message.total !== undefined) {
            obj.total = amount_1.Amount.toJSON(message.total);
        }
        return obj;
    },
    create(base) {
        return exports.OrderQuoteFees.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseOrderQuoteFees();
        message.secFee = (object.secFee !== undefined && object.secFee !== null)
            ? amount_1.Amount.fromPartial(object.secFee)
            : amount_1.Amount.fromPartial({});
        message.tafFee = (object.tafFee !== undefined && object.tafFee !== null)
            ? amount_1.Amount.fromPartial(object.tafFee)
            : amount_1.Amount.fromPartial({});
        message.total = (object.total !== undefined && object.total !== null)
            ? amount_1.Amount.fromPartial(object.total)
            : amount_1.Amount.fromPartial({});
        return message;
    },
};
function createBaseInstrumentDetails() {
    return {
        id: '',
        symbol: '',
        name: '',
        description: '',
        sector: '',
        type: InstrumentType.INVALID_INSTRUMENT_TYPE,
        image: '',
        fundamentals: undefined,
        status: InstrumentStatus.INVALID_INSTRUMENT_STATUS,
    };
}
exports.InstrumentDetails = {
    fromJSON(object) {
        const message = {
            id: isSet(object.id) ? globalThis.String(object.id) : '',
            symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
            name: isSet(object.name) ? globalThis.String(object.name) : '',
            type: isSet(object.type)
                ? instrumentTypeFromJSON(object.type)
                : InstrumentType.INVALID_INSTRUMENT_TYPE,
            status: isSet(object.status)
                ? instrumentStatusFromJSON(object.status)
                : InstrumentStatus.INVALID_INSTRUMENT_STATUS,
        };
        if (isSet(object.description)) {
            message.description = globalThis.String(object.description);
        }
        if (isSet(object.sector)) {
            message.sector = globalThis.String(object.sector);
        }
        if (isSet(object.image)) {
            message.image = globalThis.String(object.image);
        }
        if (isSet(object.fundamentals)) {
            message.fundamentals = exports.InstrumentFundamentals.fromJSON(object.fundamentals);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== '') {
            obj.id = message.id;
        }
        if (message.symbol !== '') {
            obj.symbol = message.symbol;
        }
        if (message.name !== '') {
            obj.name = message.name;
        }
        if (message.description !== undefined && message.description !== '') {
            obj.description = message.description;
        }
        if (message.sector !== undefined && message.sector !== '') {
            obj.sector = message.sector;
        }
        if (message.type !== InstrumentType.INVALID_INSTRUMENT_TYPE) {
            obj.type = instrumentTypeToJSON(message.type);
        }
        if (message.image !== undefined && message.image !== '') {
            obj.image = message.image;
        }
        if (message.fundamentals !== undefined) {
            obj.fundamentals = exports.InstrumentFundamentals.toJSON(message.fundamentals);
        }
        if (message.status !== InstrumentStatus.INVALID_INSTRUMENT_STATUS) {
            obj.status = instrumentStatusToJSON(message.status);
        }
        return obj;
    },
    create(base) {
        return exports.InstrumentDetails.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseInstrumentDetails();
        message.id = object.id ?? '';
        message.symbol = object.symbol ?? '';
        message.name = object.name ?? '';
        message.description = object.description ?? '';
        message.sector = object.sector ?? '';
        message.type = object.type ?? InstrumentType.INVALID_INSTRUMENT_TYPE;
        message.image = object.image ?? '';
        message.fundamentals = (object.fundamentals !== undefined && object.fundamentals !== null)
            ? exports.InstrumentFundamentals.fromPartial(object.fundamentals)
            : undefined;
        message.status = object.status ?? InstrumentStatus.INVALID_INSTRUMENT_STATUS;
        return message;
    },
};
function createBaseInstrumentFundamentals() {
    return {
        lowPrice52w: undefined,
        highPrice52w: undefined,
        marketCap: undefined,
        peRatio: '',
        dividendYield: '',
        earningsPerShare: undefined,
        cumulativeVolume: '',
        dividend: undefined,
        sharesOutstanding: '',
        bookValuePerShare: undefined,
        cashFlowPerShare: undefined,
        operatingIncome: undefined,
        pbRatio: '',
        volumeMovingAverage10d: '',
        volumeMovingAverage25d: '',
        volumeMovingAverage50d: '',
        priceMovingAverage50d: undefined,
        priceMovingAverage150d: undefined,
        priceMovingAverage200d: undefined,
        roe: '',
    };
}
exports.InstrumentFundamentals = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.lowPrice52w)) {
            message.lowPrice52w = amount_1.Amount.fromJSON(object.lowPrice52w);
        }
        if (isSet(object.highPrice52w)) {
            message.highPrice52w = amount_1.Amount.fromJSON(object.highPrice52w);
        }
        if (isSet(object.marketCap)) {
            message.marketCap = amount_1.Amount.fromJSON(object.marketCap);
        }
        if (isSet(object.peRatio)) {
            message.peRatio = globalThis.String(object.peRatio);
        }
        if (isSet(object.dividendYield)) {
            message.dividendYield = globalThis.String(object.dividendYield);
        }
        if (isSet(object.earningsPerShare)) {
            message.earningsPerShare = amount_1.Amount.fromJSON(object.earningsPerShare);
        }
        if (isSet(object.cumulativeVolume)) {
            message.cumulativeVolume = globalThis.String(object.cumulativeVolume);
        }
        if (isSet(object.dividend)) {
            message.dividend = amount_1.Amount.fromJSON(object.dividend);
        }
        if (isSet(object.sharesOutstanding)) {
            message.sharesOutstanding = globalThis.String(object.sharesOutstanding);
        }
        if (isSet(object.bookValuePerShare)) {
            message.bookValuePerShare = amount_1.Amount.fromJSON(object.bookValuePerShare);
        }
        if (isSet(object.cashFlowPerShare)) {
            message.cashFlowPerShare = amount_1.Amount.fromJSON(object.cashFlowPerShare);
        }
        if (isSet(object.operatingIncome)) {
            message.operatingIncome = amount_1.Amount.fromJSON(object.operatingIncome);
        }
        if (isSet(object.pbRatio)) {
            message.pbRatio = globalThis.String(object.pbRatio);
        }
        if (isSet(object.volumeMovingAverage10d)) {
            message.volumeMovingAverage10d = globalThis.String(object.volumeMovingAverage10d);
        }
        if (isSet(object.volumeMovingAverage25d)) {
            message.volumeMovingAverage25d = globalThis.String(object.volumeMovingAverage25d);
        }
        if (isSet(object.volumeMovingAverage50d)) {
            message.volumeMovingAverage50d = globalThis.String(object.volumeMovingAverage50d);
        }
        if (isSet(object.priceMovingAverage50d)) {
            message.priceMovingAverage50d = amount_1.Amount.fromJSON(object.priceMovingAverage50d);
        }
        if (isSet(object.priceMovingAverage150d)) {
            message.priceMovingAverage150d = amount_1.Amount.fromJSON(object.priceMovingAverage150d);
        }
        if (isSet(object.priceMovingAverage200d)) {
            message.priceMovingAverage200d = amount_1.Amount.fromJSON(object.priceMovingAverage200d);
        }
        if (isSet(object.roe)) {
            message.roe = globalThis.String(object.roe);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.lowPrice52w !== undefined) {
            obj.lowPrice52w = amount_1.Amount.toJSON(message.lowPrice52w);
        }
        if (message.highPrice52w !== undefined) {
            obj.highPrice52w = amount_1.Amount.toJSON(message.highPrice52w);
        }
        if (message.marketCap !== undefined) {
            obj.marketCap = amount_1.Amount.toJSON(message.marketCap);
        }
        if (message.peRatio !== undefined && message.peRatio !== '') {
            obj.peRatio = message.peRatio;
        }
        if (message.dividendYield !== undefined && message.dividendYield !== '') {
            obj.dividendYield = message.dividendYield;
        }
        if (message.earningsPerShare !== undefined) {
            obj.earningsPerShare = amount_1.Amount.toJSON(message.earningsPerShare);
        }
        if (message.cumulativeVolume !== undefined && message.cumulativeVolume !== '') {
            obj.cumulativeVolume = message.cumulativeVolume;
        }
        if (message.dividend !== undefined) {
            obj.dividend = amount_1.Amount.toJSON(message.dividend);
        }
        if (message.sharesOutstanding !== undefined && message.sharesOutstanding !== '') {
            obj.sharesOutstanding = message.sharesOutstanding;
        }
        if (message.bookValuePerShare !== undefined) {
            obj.bookValuePerShare = amount_1.Amount.toJSON(message.bookValuePerShare);
        }
        if (message.cashFlowPerShare !== undefined) {
            obj.cashFlowPerShare = amount_1.Amount.toJSON(message.cashFlowPerShare);
        }
        if (message.operatingIncome !== undefined) {
            obj.operatingIncome = amount_1.Amount.toJSON(message.operatingIncome);
        }
        if (message.pbRatio !== undefined && message.pbRatio !== '') {
            obj.pbRatio = message.pbRatio;
        }
        if (message.volumeMovingAverage10d !== undefined && message.volumeMovingAverage10d !== '') {
            obj.volumeMovingAverage10d = message.volumeMovingAverage10d;
        }
        if (message.volumeMovingAverage25d !== undefined && message.volumeMovingAverage25d !== '') {
            obj.volumeMovingAverage25d = message.volumeMovingAverage25d;
        }
        if (message.volumeMovingAverage50d !== undefined && message.volumeMovingAverage50d !== '') {
            obj.volumeMovingAverage50d = message.volumeMovingAverage50d;
        }
        if (message.priceMovingAverage50d !== undefined) {
            obj.priceMovingAverage50d = amount_1.Amount.toJSON(message.priceMovingAverage50d);
        }
        if (message.priceMovingAverage150d !== undefined) {
            obj.priceMovingAverage150d = amount_1.Amount.toJSON(message.priceMovingAverage150d);
        }
        if (message.priceMovingAverage200d !== undefined) {
            obj.priceMovingAverage200d = amount_1.Amount.toJSON(message.priceMovingAverage200d);
        }
        if (message.roe !== undefined && message.roe !== '') {
            obj.roe = message.roe;
        }
        return obj;
    },
    create(base) {
        return exports.InstrumentFundamentals.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseInstrumentFundamentals();
        message.lowPrice52w = (object.lowPrice52w !== undefined && object.lowPrice52w !== null)
            ? amount_1.Amount.fromPartial(object.lowPrice52w)
            : undefined;
        message.highPrice52w = (object.highPrice52w !== undefined && object.highPrice52w !== null)
            ? amount_1.Amount.fromPartial(object.highPrice52w)
            : undefined;
        message.marketCap = (object.marketCap !== undefined && object.marketCap !== null)
            ? amount_1.Amount.fromPartial(object.marketCap)
            : undefined;
        message.peRatio = object.peRatio ?? '';
        message.dividendYield = object.dividendYield ?? '';
        message.earningsPerShare =
            (object.earningsPerShare !== undefined && object.earningsPerShare !== null)
                ? amount_1.Amount.fromPartial(object.earningsPerShare)
                : undefined;
        message.cumulativeVolume = object.cumulativeVolume ?? '';
        message.dividend = (object.dividend !== undefined && object.dividend !== null)
            ? amount_1.Amount.fromPartial(object.dividend)
            : undefined;
        message.sharesOutstanding = object.sharesOutstanding ?? '';
        message.bookValuePerShare =
            (object.bookValuePerShare !== undefined && object.bookValuePerShare !== null)
                ? amount_1.Amount.fromPartial(object.bookValuePerShare)
                : undefined;
        message.cashFlowPerShare =
            (object.cashFlowPerShare !== undefined && object.cashFlowPerShare !== null)
                ? amount_1.Amount.fromPartial(object.cashFlowPerShare)
                : undefined;
        message.operatingIncome =
            (object.operatingIncome !== undefined && object.operatingIncome !== null)
                ? amount_1.Amount.fromPartial(object.operatingIncome)
                : undefined;
        message.pbRatio = object.pbRatio ?? '';
        message.volumeMovingAverage10d = object.volumeMovingAverage10d ?? '';
        message.volumeMovingAverage25d = object.volumeMovingAverage25d ?? '';
        message.volumeMovingAverage50d = object.volumeMovingAverage50d ?? '';
        message.priceMovingAverage50d =
            (object.priceMovingAverage50d !== undefined && object.priceMovingAverage50d !== null)
                ? amount_1.Amount.fromPartial(object.priceMovingAverage50d)
                : undefined;
        message.priceMovingAverage150d =
            (object.priceMovingAverage150d !== undefined && object.priceMovingAverage150d !== null)
                ? amount_1.Amount.fromPartial(object.priceMovingAverage150d)
                : undefined;
        message.priceMovingAverage200d =
            (object.priceMovingAverage200d !== undefined && object.priceMovingAverage200d !== null)
                ? amount_1.Amount.fromPartial(object.priceMovingAverage200d)
                : undefined;
        message.roe = object.roe ?? '';
        return message;
    },
};
function createBaseEnrollmentData() {
    return {
        identification: undefined,
        personal: undefined,
        employment: undefined,
        profile: undefined,
        riskLevel: PortfolioRiskLevel.INVALID_RISK_LEVEL,
    };
}
exports.EnrollmentData = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.identification)) {
            message.identification = exports.IdentificationData.fromJSON(object.identification);
        }
        if (isSet(object.personal)) {
            message.personal = exports.PersonalData.fromJSON(object.personal);
        }
        if (isSet(object.employment)) {
            message.employment = exports.EmploymentData.fromJSON(object.employment);
        }
        if (isSet(object.profile)) {
            message.profile = exports.InvestorProfileData.fromJSON(object.profile);
        }
        if (isSet(object.riskLevel)) {
            message.riskLevel = portfolioRiskLevelFromJSON(object.riskLevel);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.identification !== undefined) {
            obj.identification = exports.IdentificationData.toJSON(message.identification);
        }
        if (message.personal !== undefined) {
            obj.personal = exports.PersonalData.toJSON(message.personal);
        }
        if (message.employment !== undefined) {
            obj.employment = exports.EmploymentData.toJSON(message.employment);
        }
        if (message.profile !== undefined) {
            obj.profile = exports.InvestorProfileData.toJSON(message.profile);
        }
        if (message.riskLevel !== undefined && message.riskLevel !== PortfolioRiskLevel.INVALID_RISK_LEVEL) {
            obj.riskLevel = portfolioRiskLevelToJSON(message.riskLevel);
        }
        return obj;
    },
    create(base) {
        return exports.EnrollmentData.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseEnrollmentData();
        message.identification = (object.identification !== undefined && object.identification !== null)
            ? exports.IdentificationData.fromPartial(object.identification)
            : undefined;
        message.personal = (object.personal !== undefined && object.personal !== null)
            ? exports.PersonalData.fromPartial(object.personal)
            : undefined;
        message.employment = (object.employment !== undefined && object.employment !== null)
            ? exports.EmploymentData.fromPartial(object.employment)
            : undefined;
        message.profile = (object.profile !== undefined && object.profile !== null)
            ? exports.InvestorProfileData.fromPartial(object.profile)
            : undefined;
        message.riskLevel = object.riskLevel ?? PortfolioRiskLevel.INVALID_RISK_LEVEL;
        return message;
    },
};
function createBaseClosedStockAccount() {
    return { accountId: '', accountNumber: '', legalName: legal_name_1.LegalName.fromPartial({}) };
}
exports.ClosedStockAccount = {
    fromJSON(object) {
        const message = {
            accountId: isSet(object.accountId) ? globalThis.String(object.accountId) : '',
            accountNumber: isSet(object.accountNumber) ? globalThis.String(object.accountNumber) : '',
            legalName: isSet(object.legalName)
                ? legal_name_1.LegalName.fromJSON(object.legalName)
                : legal_name_1.LegalName.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.accountId !== '') {
            obj.accountId = message.accountId;
        }
        if (message.accountNumber !== '') {
            obj.accountNumber = message.accountNumber;
        }
        if (message.legalName !== undefined) {
            obj.legalName = legal_name_1.LegalName.toJSON(message.legalName);
        }
        return obj;
    },
    create(base) {
        return exports.ClosedStockAccount.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseClosedStockAccount();
        message.accountId = object.accountId ?? '';
        message.accountNumber = object.accountNumber ?? '';
        message.legalName = (object.legalName !== undefined && object.legalName !== null)
            ? legal_name_1.LegalName.fromPartial(object.legalName)
            : legal_name_1.LegalName.fromPartial({});
        return message;
    },
};
function stockErrorCodeFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_STOCK_ERROR_CODE':
            return StockErrorCode.INVALID_STOCK_ERROR_CODE;
        case 1:
        case 'INSTRUMENT_NOT_FOUND':
            return StockErrorCode.INSTRUMENT_NOT_FOUND;
        case 2:
        case 'INVALID_COMPRESSION_VALUE':
            return StockErrorCode.INVALID_COMPRESSION_VALUE;
        case 3:
        case 'INVALID_PRICE_DATA':
            return StockErrorCode.INVALID_PRICE_DATA;
        case 4:
        case 'ENROLLMENT_REQUIRED':
            return StockErrorCode.ENROLLMENT_REQUIRED;
        case 5:
        case 'ORDER_NOT_FOUND':
            return StockErrorCode.ORDER_NOT_FOUND;
        case 6:
        case 'INVALID_ORDER':
            return StockErrorCode.INVALID_ORDER;
        case 7:
        case 'CHART_DATA_THROTTLED':
            return StockErrorCode.CHART_DATA_THROTTLED;
        case 8:
        case 'PATTERN_DAY_TRADER':
            return StockErrorCode.PATTERN_DAY_TRADER;
        case 9:
        case 'PENDING_ORDER_ALREADY_EXISTS':
            return StockErrorCode.PENDING_ORDER_ALREADY_EXISTS;
        case 10:
        case 'MINIMUM_BALANCE':
            return StockErrorCode.MINIMUM_BALANCE;
        case 11:
        case 'QUOTE_NOT_FOUND':
            return StockErrorCode.QUOTE_NOT_FOUND;
        case 12:
        case 'ASSETS_TRANSFER_FAILURE':
            return StockErrorCode.ASSETS_TRANSFER_FAILURE;
        case 13:
        case 'INVALID_ADDRESS':
            return StockErrorCode.INVALID_ADDRESS;
        case 14:
        case 'INVALID_EMAIL':
            return StockErrorCode.INVALID_EMAIL;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return StockErrorCode.UNRECOGNIZED;
    }
}
exports.stockErrorCodeFromJSON = stockErrorCodeFromJSON;
function stockErrorCodeToJSON(object) {
    switch (object) {
        case StockErrorCode.INVALID_STOCK_ERROR_CODE:
            return 'INVALID_STOCK_ERROR_CODE';
        case StockErrorCode.INSTRUMENT_NOT_FOUND:
            return 'INSTRUMENT_NOT_FOUND';
        case StockErrorCode.INVALID_COMPRESSION_VALUE:
            return 'INVALID_COMPRESSION_VALUE';
        case StockErrorCode.INVALID_PRICE_DATA:
            return 'INVALID_PRICE_DATA';
        case StockErrorCode.ENROLLMENT_REQUIRED:
            return 'ENROLLMENT_REQUIRED';
        case StockErrorCode.ORDER_NOT_FOUND:
            return 'ORDER_NOT_FOUND';
        case StockErrorCode.INVALID_ORDER:
            return 'INVALID_ORDER';
        case StockErrorCode.CHART_DATA_THROTTLED:
            return 'CHART_DATA_THROTTLED';
        case StockErrorCode.PATTERN_DAY_TRADER:
            return 'PATTERN_DAY_TRADER';
        case StockErrorCode.PENDING_ORDER_ALREADY_EXISTS:
            return 'PENDING_ORDER_ALREADY_EXISTS';
        case StockErrorCode.MINIMUM_BALANCE:
            return 'MINIMUM_BALANCE';
        case StockErrorCode.QUOTE_NOT_FOUND:
            return 'QUOTE_NOT_FOUND';
        case StockErrorCode.ASSETS_TRANSFER_FAILURE:
            return 'ASSETS_TRANSFER_FAILURE';
        case StockErrorCode.INVALID_ADDRESS:
            return 'INVALID_ADDRESS';
        case StockErrorCode.INVALID_EMAIL:
            return 'INVALID_EMAIL';
        case StockErrorCode.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.stockErrorCodeToJSON = stockErrorCodeToJSON;
function portfolioRiskLevelFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_RISK_LEVEL':
            return PortfolioRiskLevel.INVALID_RISK_LEVEL;
        case 1:
        case 'CONSERVATIVE':
            return PortfolioRiskLevel.CONSERVATIVE;
        case 2:
        case 'MODERATE':
            return PortfolioRiskLevel.MODERATE;
        case 3:
        case 'AGGRESSIVE':
            return PortfolioRiskLevel.AGGRESSIVE;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return PortfolioRiskLevel.UNRECOGNIZED;
    }
}
exports.portfolioRiskLevelFromJSON = portfolioRiskLevelFromJSON;
function portfolioRiskLevelToJSON(object) {
    switch (object) {
        case PortfolioRiskLevel.INVALID_RISK_LEVEL:
            return 'INVALID_RISK_LEVEL';
        case PortfolioRiskLevel.CONSERVATIVE:
            return 'CONSERVATIVE';
        case PortfolioRiskLevel.MODERATE:
            return 'MODERATE';
        case PortfolioRiskLevel.AGGRESSIVE:
            return 'AGGRESSIVE';
        case PortfolioRiskLevel.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.portfolioRiskLevelToJSON = portfolioRiskLevelToJSON;
function enrollmentStatusFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_ENROLLMENT_STATUS':
            return EnrollmentStatus.INVALID_ENROLLMENT_STATUS;
        case 1:
        case 'ACTIVE':
            return EnrollmentStatus.ACTIVE;
        case 2:
        case 'ENROLLED':
            return EnrollmentStatus.ENROLLED;
        case 3:
        case 'CLOSED':
            return EnrollmentStatus.CLOSED;
        case 4:
        case 'SELL_ONLY':
            return EnrollmentStatus.SELL_ONLY;
        case 5:
        case 'OPEN_NO_NEW_TRADES':
            return EnrollmentStatus.OPEN_NO_NEW_TRADES;
        case 6:
        case 'GRADUATED':
            return EnrollmentStatus.GRADUATED;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return EnrollmentStatus.UNRECOGNIZED;
    }
}
exports.enrollmentStatusFromJSON = enrollmentStatusFromJSON;
function enrollmentStatusToJSON(object) {
    switch (object) {
        case EnrollmentStatus.INVALID_ENROLLMENT_STATUS:
            return 'INVALID_ENROLLMENT_STATUS';
        case EnrollmentStatus.ACTIVE:
            return 'ACTIVE';
        case EnrollmentStatus.ENROLLED:
            return 'ENROLLED';
        case EnrollmentStatus.CLOSED:
            return 'CLOSED';
        case EnrollmentStatus.SELL_ONLY:
            return 'SELL_ONLY';
        case EnrollmentStatus.OPEN_NO_NEW_TRADES:
            return 'OPEN_NO_NEW_TRADES';
        case EnrollmentStatus.GRADUATED:
            return 'GRADUATED';
        case EnrollmentStatus.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.enrollmentStatusToJSON = enrollmentStatusToJSON;
function accountClosabilityFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_ACCOUNT_CLOSABILITY':
            return AccountClosability.INVALID_ACCOUNT_CLOSABILITY;
        case 1:
        case 'CLOSABLE':
            return AccountClosability.CLOSABLE;
        case 2:
        case 'BALANCE_NOT_ZERO':
            return AccountClosability.BALANCE_NOT_ZERO;
        case 3:
        case 'OPEN_POSITIONS':
            return AccountClosability.OPEN_POSITIONS;
        case 4:
        case 'PENDING_ORDERS':
            return AccountClosability.PENDING_ORDERS;
        case 6:
        case 'PENDING_ASSET_TRANSFERS':
            return AccountClosability.PENDING_ASSET_TRANSFERS;
        case 5:
        case 'DEPENDENT_ACCOUNT':
            return AccountClosability.DEPENDENT_ACCOUNT;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return AccountClosability.UNRECOGNIZED;
    }
}
exports.accountClosabilityFromJSON = accountClosabilityFromJSON;
function accountClosabilityToJSON(object) {
    switch (object) {
        case AccountClosability.INVALID_ACCOUNT_CLOSABILITY:
            return 'INVALID_ACCOUNT_CLOSABILITY';
        case AccountClosability.CLOSABLE:
            return 'CLOSABLE';
        case AccountClosability.BALANCE_NOT_ZERO:
            return 'BALANCE_NOT_ZERO';
        case AccountClosability.OPEN_POSITIONS:
            return 'OPEN_POSITIONS';
        case AccountClosability.PENDING_ORDERS:
            return 'PENDING_ORDERS';
        case AccountClosability.PENDING_ASSET_TRANSFERS:
            return 'PENDING_ASSET_TRANSFERS';
        case AccountClosability.DEPENDENT_ACCOUNT:
            return 'DEPENDENT_ACCOUNT';
        case AccountClosability.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.accountClosabilityToJSON = accountClosabilityToJSON;
function assetTransferStatusFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_ASSET_TRANSFER_STATUS':
            return AssetTransferStatus.INVALID_ASSET_TRANSFER_STATUS;
        case 1:
        case 'ASSET_TRANSFER_STARTED':
            return AssetTransferStatus.ASSET_TRANSFER_STARTED;
        case 2:
        case 'ASSET_TRANSFER_PENDING':
            return AssetTransferStatus.ASSET_TRANSFER_PENDING;
        case 3:
        case 'ASSET_TRANSFER_COMPLETED':
            return AssetTransferStatus.ASSET_TRANSFER_COMPLETED;
        case 4:
        case 'ASSET_TRANSFER_ON_HOLD':
            return AssetTransferStatus.ASSET_TRANSFER_ON_HOLD;
        case 5:
        case 'ASSET_TRANSFER_FAILED':
            return AssetTransferStatus.ASSET_TRANSFER_FAILED;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return AssetTransferStatus.UNRECOGNIZED;
    }
}
exports.assetTransferStatusFromJSON = assetTransferStatusFromJSON;
function assetTransferStatusToJSON(object) {
    switch (object) {
        case AssetTransferStatus.INVALID_ASSET_TRANSFER_STATUS:
            return 'INVALID_ASSET_TRANSFER_STATUS';
        case AssetTransferStatus.ASSET_TRANSFER_STARTED:
            return 'ASSET_TRANSFER_STARTED';
        case AssetTransferStatus.ASSET_TRANSFER_PENDING:
            return 'ASSET_TRANSFER_PENDING';
        case AssetTransferStatus.ASSET_TRANSFER_COMPLETED:
            return 'ASSET_TRANSFER_COMPLETED';
        case AssetTransferStatus.ASSET_TRANSFER_ON_HOLD:
            return 'ASSET_TRANSFER_ON_HOLD';
        case AssetTransferStatus.ASSET_TRANSFER_FAILED:
            return 'ASSET_TRANSFER_FAILED';
        case AssetTransferStatus.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.assetTransferStatusToJSON = assetTransferStatusToJSON;
function stockGraduationStatusFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_STOCK_GRADUATION_STATUS':
            return StockGraduationStatus.INVALID_STOCK_GRADUATION_STATUS;
        case 1:
        case 'PENDING':
            return StockGraduationStatus.PENDING;
        case 2:
        case 'COMPLETED':
            return StockGraduationStatus.COMPLETED;
        case 3:
        case 'ON_HOLD':
            return StockGraduationStatus.ON_HOLD;
        case 4:
        case 'FAILED':
            return StockGraduationStatus.FAILED;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return StockGraduationStatus.UNRECOGNIZED;
    }
}
exports.stockGraduationStatusFromJSON = stockGraduationStatusFromJSON;
function stockGraduationStatusToJSON(object) {
    switch (object) {
        case StockGraduationStatus.INVALID_STOCK_GRADUATION_STATUS:
            return 'INVALID_STOCK_GRADUATION_STATUS';
        case StockGraduationStatus.PENDING:
            return 'PENDING';
        case StockGraduationStatus.COMPLETED:
            return 'COMPLETED';
        case StockGraduationStatus.ON_HOLD:
            return 'ON_HOLD';
        case StockGraduationStatus.FAILED:
            return 'FAILED';
        case StockGraduationStatus.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.stockGraduationStatusToJSON = stockGraduationStatusToJSON;
function instrumentTypeFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_INSTRUMENT_TYPE':
            return InstrumentType.INVALID_INSTRUMENT_TYPE;
        case 1:
        case 'EQUITY':
            return InstrumentType.EQUITY;
        case 2:
        case 'ETF':
            return InstrumentType.ETF;
        case 3:
        case 'ADR':
            return InstrumentType.ADR;
        case 4:
        case 'ETN':
            return InstrumentType.ETN;
        case 5:
        case 'ALTERNATIVE_ASSET':
            return InstrumentType.ALTERNATIVE_ASSET;
        case 6:
        case 'CRYPTO':
            return InstrumentType.CRYPTO;
        case 7:
        case 'MUTUAL_FUND':
            return InstrumentType.MUTUAL_FUND;
        case 8:
        case 'OPTIONS':
            return InstrumentType.OPTIONS;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return InstrumentType.UNRECOGNIZED;
    }
}
exports.instrumentTypeFromJSON = instrumentTypeFromJSON;
function instrumentTypeToJSON(object) {
    switch (object) {
        case InstrumentType.INVALID_INSTRUMENT_TYPE:
            return 'INVALID_INSTRUMENT_TYPE';
        case InstrumentType.EQUITY:
            return 'EQUITY';
        case InstrumentType.ETF:
            return 'ETF';
        case InstrumentType.ADR:
            return 'ADR';
        case InstrumentType.ETN:
            return 'ETN';
        case InstrumentType.ALTERNATIVE_ASSET:
            return 'ALTERNATIVE_ASSET';
        case InstrumentType.CRYPTO:
            return 'CRYPTO';
        case InstrumentType.MUTUAL_FUND:
            return 'MUTUAL_FUND';
        case InstrumentType.OPTIONS:
            return 'OPTIONS';
        case InstrumentType.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.instrumentTypeToJSON = instrumentTypeToJSON;
function instrumentStatusFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_INSTRUMENT_STATUS':
            return InstrumentStatus.INVALID_INSTRUMENT_STATUS;
        case 1:
        case 'INSTRUMENT_ACTIVE':
            return InstrumentStatus.INSTRUMENT_ACTIVE;
        case 2:
        case 'INSTRUMENT_INACTIVE':
            return InstrumentStatus.INSTRUMENT_INACTIVE;
        case 3:
        case 'INSTRUMENT_CLOSE_ONLY':
            return InstrumentStatus.INSTRUMENT_CLOSE_ONLY;
        case 4:
        case 'INSTRUMENT_HALTED':
            return InstrumentStatus.INSTRUMENT_HALTED;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return InstrumentStatus.UNRECOGNIZED;
    }
}
exports.instrumentStatusFromJSON = instrumentStatusFromJSON;
function instrumentStatusToJSON(object) {
    switch (object) {
        case InstrumentStatus.INVALID_INSTRUMENT_STATUS:
            return 'INVALID_INSTRUMENT_STATUS';
        case InstrumentStatus.INSTRUMENT_ACTIVE:
            return 'INSTRUMENT_ACTIVE';
        case InstrumentStatus.INSTRUMENT_INACTIVE:
            return 'INSTRUMENT_INACTIVE';
        case InstrumentStatus.INSTRUMENT_CLOSE_ONLY:
            return 'INSTRUMENT_CLOSE_ONLY';
        case InstrumentStatus.INSTRUMENT_HALTED:
            return 'INSTRUMENT_HALTED';
        case InstrumentStatus.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.instrumentStatusToJSON = instrumentStatusToJSON;
function instrumentRiskFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_INSTRUMENT_RISK':
            return InstrumentRisk.INVALID_INSTRUMENT_RISK;
        case 1:
        case 'RISK_HIGH':
            return InstrumentRisk.RISK_HIGH;
        case 2:
        case 'RISK_MEDIUM':
            return InstrumentRisk.RISK_MEDIUM;
        case 3:
        case 'RISK_LOW':
            return InstrumentRisk.RISK_LOW;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return InstrumentRisk.UNRECOGNIZED;
    }
}
exports.instrumentRiskFromJSON = instrumentRiskFromJSON;
function instrumentRiskToJSON(object) {
    switch (object) {
        case InstrumentRisk.INVALID_INSTRUMENT_RISK:
            return 'INVALID_INSTRUMENT_RISK';
        case InstrumentRisk.RISK_HIGH:
            return 'RISK_HIGH';
        case InstrumentRisk.RISK_MEDIUM:
            return 'RISK_MEDIUM';
        case InstrumentRisk.RISK_LOW:
            return 'RISK_LOW';
        case InstrumentRisk.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.instrumentRiskToJSON = instrumentRiskToJSON;
function instrumentSourceFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_INSTRUMENT_SOURCE':
            return InstrumentSource.INVALID_INSTRUMENT_SOURCE;
        case 1:
        case 'SOURCE_STEP':
            return InstrumentSource.SOURCE_STEP;
        case 2:
        case 'SOURCE_DRIVE_WEALTH':
            return InstrumentSource.SOURCE_DRIVE_WEALTH;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return InstrumentSource.UNRECOGNIZED;
    }
}
exports.instrumentSourceFromJSON = instrumentSourceFromJSON;
function instrumentSourceToJSON(object) {
    switch (object) {
        case InstrumentSource.INVALID_INSTRUMENT_SOURCE:
            return 'INVALID_INSTRUMENT_SOURCE';
        case InstrumentSource.SOURCE_STEP:
            return 'SOURCE_STEP';
        case InstrumentSource.SOURCE_DRIVE_WEALTH:
            return 'SOURCE_DRIVE_WEALTH';
        case InstrumentSource.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.instrumentSourceToJSON = instrumentSourceToJSON;
function employmentDataEmploymentStatusFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_EMPLOYMENT_STATUS':
            return EmploymentDataEmploymentStatus.INVALID_EMPLOYMENT_STATUS;
        case 1:
        case 'EMPLOYED':
            return EmploymentDataEmploymentStatus.EMPLOYED;
        case 2:
        case 'RETIRED':
            return EmploymentDataEmploymentStatus.RETIRED;
        case 3:
        case 'STUDENT':
            return EmploymentDataEmploymentStatus.STUDENT;
        case 4:
        case 'UNEMPLOYED':
            return EmploymentDataEmploymentStatus.UNEMPLOYED;
        case 5:
        case 'SELF_EMPLOYED':
            return EmploymentDataEmploymentStatus.SELF_EMPLOYED;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return EmploymentDataEmploymentStatus.UNRECOGNIZED;
    }
}
exports.employmentDataEmploymentStatusFromJSON = employmentDataEmploymentStatusFromJSON;
function employmentDataEmploymentStatusToJSON(object) {
    switch (object) {
        case EmploymentDataEmploymentStatus.INVALID_EMPLOYMENT_STATUS:
            return 'INVALID_EMPLOYMENT_STATUS';
        case EmploymentDataEmploymentStatus.EMPLOYED:
            return 'EMPLOYED';
        case EmploymentDataEmploymentStatus.RETIRED:
            return 'RETIRED';
        case EmploymentDataEmploymentStatus.STUDENT:
            return 'STUDENT';
        case EmploymentDataEmploymentStatus.UNEMPLOYED:
            return 'UNEMPLOYED';
        case EmploymentDataEmploymentStatus.SELF_EMPLOYED:
            return 'SELF_EMPLOYED';
        case EmploymentDataEmploymentStatus.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.employmentDataEmploymentStatusToJSON = employmentDataEmploymentStatusToJSON;
function investorProfileDataInvestmentExperienceFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_INVESTMENT_EXPERIENCE':
            return InvestorProfileDataInvestmentExperience.INVALID_INVESTMENT_EXPERIENCE;
        case 1:
        case 'NONE':
            return InvestorProfileDataInvestmentExperience.NONE;
        case 2:
        case 'YRS_1_2':
            return InvestorProfileDataInvestmentExperience.YRS_1_2;
        case 3:
        case 'YRS_3_5':
            return InvestorProfileDataInvestmentExperience.YRS_3_5;
        case 4:
        case 'YRS_5_10':
            return InvestorProfileDataInvestmentExperience.YRS_5_10;
        case 5:
        case 'YRS_10_PLUS':
            return InvestorProfileDataInvestmentExperience.YRS_10_PLUS;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return InvestorProfileDataInvestmentExperience.UNRECOGNIZED;
    }
}
exports.investorProfileDataInvestmentExperienceFromJSON = investorProfileDataInvestmentExperienceFromJSON;
function investorProfileDataInvestmentExperienceToJSON(object) {
    switch (object) {
        case InvestorProfileDataInvestmentExperience.INVALID_INVESTMENT_EXPERIENCE:
            return 'INVALID_INVESTMENT_EXPERIENCE';
        case InvestorProfileDataInvestmentExperience.NONE:
            return 'NONE';
        case InvestorProfileDataInvestmentExperience.YRS_1_2:
            return 'YRS_1_2';
        case InvestorProfileDataInvestmentExperience.YRS_3_5:
            return 'YRS_3_5';
        case InvestorProfileDataInvestmentExperience.YRS_5_10:
            return 'YRS_5_10';
        case InvestorProfileDataInvestmentExperience.YRS_10_PLUS:
            return 'YRS_10_PLUS';
        case InvestorProfileDataInvestmentExperience.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.investorProfileDataInvestmentExperienceToJSON = investorProfileDataInvestmentExperienceToJSON;
function investorProfileDataRiskToleranceFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_RISK_TOLERANCE':
            return InvestorProfileDataRiskTolerance.INVALID_RISK_TOLERANCE;
        case 1:
        case 'LOW':
            return InvestorProfileDataRiskTolerance.LOW;
        case 2:
        case 'MODERATE':
            return InvestorProfileDataRiskTolerance.MODERATE;
        case 3:
        case 'SPECULATION':
            return InvestorProfileDataRiskTolerance.SPECULATION;
        case 4:
        case 'HIGH':
            return InvestorProfileDataRiskTolerance.HIGH;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return InvestorProfileDataRiskTolerance.UNRECOGNIZED;
    }
}
exports.investorProfileDataRiskToleranceFromJSON = investorProfileDataRiskToleranceFromJSON;
function investorProfileDataRiskToleranceToJSON(object) {
    switch (object) {
        case InvestorProfileDataRiskTolerance.INVALID_RISK_TOLERANCE:
            return 'INVALID_RISK_TOLERANCE';
        case InvestorProfileDataRiskTolerance.LOW:
            return 'LOW';
        case InvestorProfileDataRiskTolerance.MODERATE:
            return 'MODERATE';
        case InvestorProfileDataRiskTolerance.SPECULATION:
            return 'SPECULATION';
        case InvestorProfileDataRiskTolerance.HIGH:
            return 'HIGH';
        case InvestorProfileDataRiskTolerance.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.investorProfileDataRiskToleranceToJSON = investorProfileDataRiskToleranceToJSON;
function investorProfileDataInvestmentObjectiveFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_INVESTMENT_OBJECTIVE':
            return InvestorProfileDataInvestmentObjective.INVALID_INVESTMENT_OBJECTIVE;
        case 1:
        case 'LONG_TERM':
            return InvestorProfileDataInvestmentObjective.LONG_TERM;
        case 2:
        case 'INFREQUENT':
            return InvestorProfileDataInvestmentObjective.INFREQUENT;
        case 3:
        case 'FREQUENT':
            return InvestorProfileDataInvestmentObjective.FREQUENT;
        case 4:
        case 'ACTIVE_DAILY':
            return InvestorProfileDataInvestmentObjective.ACTIVE_DAILY;
        case 5:
        case 'NEW':
            return InvestorProfileDataInvestmentObjective.NEW;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return InvestorProfileDataInvestmentObjective.UNRECOGNIZED;
    }
}
exports.investorProfileDataInvestmentObjectiveFromJSON = investorProfileDataInvestmentObjectiveFromJSON;
function investorProfileDataInvestmentObjectiveToJSON(object) {
    switch (object) {
        case InvestorProfileDataInvestmentObjective.INVALID_INVESTMENT_OBJECTIVE:
            return 'INVALID_INVESTMENT_OBJECTIVE';
        case InvestorProfileDataInvestmentObjective.LONG_TERM:
            return 'LONG_TERM';
        case InvestorProfileDataInvestmentObjective.INFREQUENT:
            return 'INFREQUENT';
        case InvestorProfileDataInvestmentObjective.FREQUENT:
            return 'FREQUENT';
        case InvestorProfileDataInvestmentObjective.ACTIVE_DAILY:
            return 'ACTIVE_DAILY';
        case InvestorProfileDataInvestmentObjective.NEW:
            return 'NEW';
        case InvestorProfileDataInvestmentObjective.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.investorProfileDataInvestmentObjectiveToJSON = investorProfileDataInvestmentObjectiveToJSON;
function equityQuoteMarketConditionFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_MARKET_CONDITION':
            return EquityQuoteMarketCondition.INVALID_MARKET_CONDITION;
        case 1:
        case 'NORMAL':
            return EquityQuoteMarketCondition.NORMAL;
        case 2:
        case 'TRADING_HALT':
            return EquityQuoteMarketCondition.TRADING_HALT;
        case 3:
        case 'UNKNOWN':
            return EquityQuoteMarketCondition.UNKNOWN;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return EquityQuoteMarketCondition.UNRECOGNIZED;
    }
}
exports.equityQuoteMarketConditionFromJSON = equityQuoteMarketConditionFromJSON;
function equityQuoteMarketConditionToJSON(object) {
    switch (object) {
        case EquityQuoteMarketCondition.INVALID_MARKET_CONDITION:
            return 'INVALID_MARKET_CONDITION';
        case EquityQuoteMarketCondition.NORMAL:
            return 'NORMAL';
        case EquityQuoteMarketCondition.TRADING_HALT:
            return 'TRADING_HALT';
        case EquityQuoteMarketCondition.UNKNOWN:
            return 'UNKNOWN';
        case EquityQuoteMarketCondition.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.equityQuoteMarketConditionToJSON = equityQuoteMarketConditionToJSON;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=stock.js.map